(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
/* Bundle v2 cart actions (rb-bundle-cart): free-gift select / auto-remove and best-seller quick add.
   Delegated on document so it keeps working after the drawer and cart page re-render. */
(() => {
  if (window.__rbBundleCart) return;
  window.__rbBundleCart = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  /* ---- Deal-tier cart attributes (_deal_tier / _gift_tiers) for order tagging in Shopify Flow ----
     Watches every cart mutation made with fetch (builder, drawer, quick picker, PDP, line items), waits until
     none is in flight, asks the rb-deal-tier section for the tier (same rules as Multi-Deal v2) and writes the
     attributes only when they changed. Checkout waits for a pending write so the order always carries them. */
  (() => {
    const rawFetch = window.fetch.bind(window);
    const MUT = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    let inflight = 0, timer = null, running = null;
    const schedule = (ms) => { clearTimeout(timer); timer = setTimeout(() => { timer = null; sync(); }, ms == null ? 600 : ms); };
    async function sync() {
      if (inflight > 0) { schedule(300); return; }
      if (running) { await running; schedule(100); return; }
      running = (async () => {
        try {
          const html = await (await rawFetch(root + '?section_id=rb-deal-tier', { cache: 'no-store' })).text();
          const m = html.match(/<script type="application\/json" data-rb-deal-tier>([\s\S]*?)<\/script>/);
          if (!m) return;
          const t = JSON.parse(m[1]);
          if (t.deal_tier === t.cur_deal_tier && t.gift_tiers === t.cur_gift_tiers && t.source === t.cur_source) return;
          if (!t.items && !t.cur_deal_tier) return;
          await rawFetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ attributes: { _deal_tier: t.deal_tier, _gift_tiers: t.gift_tiers, _source: t.source } }) });
        } catch (e) {}
      })();
      try { await running; } finally { running = null; }
    }
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const isMut = MUT.test(url);
      if (isMut) inflight++;
      const req = rawFetch(input, init);
      if (isMut) req.then(() => {}, () => {}).then(() => { inflight = Math.max(0, inflight - 1); schedule(); });
      return req;
    };
    window.rbDealTierSync = () => { schedule(0); };
    /* Checkout: finish any pending write first, then continue with the same submit button. */
    document.addEventListener('submit', (e) => {
      const btn = e.submitter;
      if (!btn || btn.name !== 'checkout' || btn.dataset.rbTierOk) return;
      if (!timer && !running && inflight === 0) return;
      e.preventDefault();
      clearTimeout(timer); timer = null;
      const go = () => { btn.dataset.rbTierOk = '1'; e.target.requestSubmit ? e.target.requestSubmit(btn) : btn.click(); };
      Promise.race([sync(), new Promise((r) => setTimeout(r, 2500))]).then(go, go);
    }, true);
    /* Page loads (e.g. after a classic form add) re-check once. */
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => schedule(800)); else schedule(800);
  })();
  const post = (url, body) => fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
  async function refresh() {
    if (document.querySelector('.rb-bc--page')) { window.location.reload(); return; }
    const sections = ['cart-drawer', 'cart-count'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    const cart = await (await fetch(root + 'cart.js')).json();
    cart.sections = await (await fetch(root + '?sections=' + sections.join(','), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })).json();
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
  }
  document.addEventListener('click', async (e) => {
    const gift = e.target.closest('[data-rb-gift]');
    const add = e.target.closest('[data-rb-add]');
    const btn = gift || add;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    try {
      const item = gift
        ? { id: parseInt(gift.dataset.rbGift, 10), quantity: 1, properties: { _gift: gift.dataset.tier } }
        : { id: parseInt(add.dataset.rbAdd, 10), quantity: 1 };
      const res = await post('cart/add.js', { items: [item] });
      if (!res.ok) throw new Error('add failed');
      await refresh();
    } catch (err) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
  });
  /* Compact drawer line items: -/+ step the Impact quantity input, which posts the change itself. */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-rb-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('.quantity-input');
    if (!input) return;
    input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.rbStep, 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  /* ---- Quick picker: "Pick N" opens the builder's scent picker over the drawer / cart ---- */
  const FAMS = [
    { key: 'all', label: 'All scents', match: [] },
    { key: 'fresh', label: 'Fresh & clean', match: ['Fresh', 'Laundry', 'Spa'] },
    { key: 'fruity', label: 'Fruity', match: ['Fruity'] },
    { key: 'sweet', label: 'Sweet', match: ['Sweet', 'Bakery'] },
    { key: 'floral', label: 'Floral', match: ['Floral', 'Lavender'] },
    { key: 'warm', label: 'Warm & cosy', match: ['Autumn', 'Oud'] },
    { key: 'perfume', label: 'Perfume-inspired', match: ['Perfume', 'Inspired By', 'Aftershave'] }
  ];
  const TYPES = [{ key: 'all', label: 'All' }, { key: 'snap', label: 'Snap Bars' }, { key: 'carpet', label: 'Carpet' }, { key: 'mist', label: 'Room Mists' }];
  const TYPE_LABEL = { snap: 'Snap Bar Wax Melt', carpet: 'Carpet Freshener · 300g', mist: 'Mini Room Mist · 10ml' };
  const esc = (t) => { const d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; };
  const gbp = (v) => '£' + Math.abs(v).toFixed(2);
  /* Deals the quick picker can fill (the cart card passes data-deal). Prices mirror the Multi-Deal v2 function. */
  const QPD = {
    '8for24': { url: 'collections/any-8-for-24', from: '8for24-builder', types: TYPES, labels: TYPE_LABEL,
      ladder: (n) => ladder(n), tierOf: (n) => (n >= 12 ? '12 for £35' : (n >= 8 ? '8 for £24' : '')) },
    '3for35': { url: 'collections/any-3-for-35', from: '3for35-builder',
      types: [{ key: 'all', label: 'All' }, { key: 'reed', label: 'Reed Diffusers' }, { key: 'candle', label: 'Candles' }],
      labels: { reed: 'Reed Diffuser', candle: 'Soy Wax Candle' },
      ladder: (n) => Math.floor(n / 3) * 35 + (n % 3) * 16, tierOf: (n) => (n >= 3 ? '3 for £35' : '') },
    '3for30': { url: 'collections/room-linen-sprays', from: '3for30-builder',
      types: [{ key: 'all', label: 'All room mists' }], labels: { rs: 'Room Mist · 100ml' },
      ladder: (n) => Math.floor(n / 3) * 30 + (n % 3) * 12, tierOf: (n) => (n >= 3 ? '3 for £30' : '') }
  };
  const tierOf = (n) => QPD['8for24'].tierOf(n);
  /* CTA copy by basket delta: adding to an unfinished deal can make it cheaper, so never show a negative price. */
  const dealCta = (n, pool, cfg) => {
    cfg = cfg || QPD['8for24'];
    const before = cfg.ladder(pool), after = cfg.ladder(pool + n), d = Math.round((after - before) * 100) / 100;
    const t = cfg.tierOf(pool + n), newTier = t && t !== cfg.tierOf(pool);
    if (d < 0) return 'Add ' + n + ' & save ' + gbp(d) + (t ? ' · ' + t : '');
    if (d === 0) return 'Add ' + n + ' at no extra cost' + (t ? ' · ' + t : '');
    return 'Add ' + n + ' · +' + gbp(d) + (newTier ? ' → ' + t : '');
  };
  window.rbDealCta = dealCta;
  const ladder = (n) => { let best = n * 5; for (let a = 0; a * 12 <= n; a++) for (let b = 0; a * 12 + b * 8 <= n; b++) { const p = a * 35 + b * 24 + (n - a * 12 - b * 8) * 5; if (p < best) best = p; } return best; };
  async function loadProducts(deal) {
    window.__rbQPProducts = window.__rbQPProducts || {};
    if (window.__rbQPProducts[deal]) return window.__rbQPProducts[deal];
    const html = await (await fetch(root + QPD[deal].url + '?section_id=rb-8-for-24')).text();
    const raw = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rb8-products]');
    const list = raw ? JSON.parse(raw.textContent) : [];
    const ranked = list.slice().sort((x, y) => (y.reviews || 0) - (x.reviews || 0));
    const rank = new Map(ranked.map((p, i) => [String(p.id), i]));
    const best = new Set(ranked.slice(0, 12).filter((p) => (p.reviews || 0) > 0).map((p) => String(p.id)));
    return (window.__rbQPProducts[deal] = { list, rank, best });
  }
  class RbQuickPicker {
    constructor(need, pool, deal) {
      this.need = need; this.pool = pool; this.picks = [];
      this.deal = QPD[deal] ? deal : '8for24'; this.cfg = QPD[this.deal];
      this.state = { type: 'all', fam: 'all', q: '', bestSort: true };
      this.el = document.createElement('div');
      this.el.className = 'rb-qp';
      this.el.innerHTML = `<div class="rb-qp__sheet" role="dialog" aria-modal="true" aria-label="Pick your scents">
        <div class="rb-qp__head">
          <div class="rb-qp__top"><div><p class="rb-qp__title">Pick ${need} more</p><p class="rb-qp__count" data-qp-count></p></div>
          <button type="button" class="rb-qp__close" data-qp-close aria-label="Close"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6L6 18"></path></svg></button></div>
          <div class="rb-qp__bar"><span data-qp-bar></span></div>
          <input type="text" class="rb-qp__search" data-qp-search placeholder="Search scent" aria-label="Search scent" autocomplete="off">
          <div class="rb-qp__types" data-qp-types></div>
          <div class="rb-qp__famwrap"><div class="rb-qp__fams" data-qp-fams></div><span class="rb-qp__fade" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M9 6l6 6-6 6"></path></svg></span></div>
          <div class="rb-qp__meta"><span data-qp-n></span><button type="button" class="rb-qp__sort" data-qp-sort>Sort: Best sellers</button></div>
        </div>
        <div class="rb-qp__list" data-qp-list><p class="rb-qp__loading">Loading scents…</p></div>
        <div class="rb-qp__foot"><p class="rb-qp__err" data-qp-err hidden></p><button type="button" class="rb-qp__go" data-qp-go disabled>Pick your scents</button></div>
      </div>`;
      document.body.appendChild(this.el);
      this.q = (sel) => this.el.querySelector(sel);
      this.position();
      this.el.addEventListener('click', (e) => { if (e.target === this.el) this.close(); });
      this.q('[data-qp-close]').addEventListener('click', () => this.close());
      this.q('[data-qp-search]').addEventListener('input', (e) => { this.state.q = e.target.value; this.renderList(); });
      this.q('[data-qp-sort]').addEventListener('click', (e) => { this.state.bestSort = !this.state.bestSort; e.target.textContent = this.state.bestSort ? 'Sort: Best sellers' : 'Sort: A to Z'; this.renderList(); });
      this.q('[data-qp-go]').addEventListener('click', () => this.addToCart());
      /* count + sort scroll with the list, keeping the sticky header short */
      this.meta = this.q('.rb-qp__meta'); this.meta.remove();
      this.onKey = (e) => { if (e.key === 'Escape') this.close(); };
      document.addEventListener('keydown', this.onKey);
      requestAnimationFrame(() => this.el.classList.add('is-open'));
      this.inCart = {};
      fetch(root + 'cart.js', { cache: 'no-store' }).then((r) => r.json()).then((c) => { c.items.forEach((it) => { this.inCart[String(it.variant_id)] = (this.inCart[String(it.variant_id)] || 0) + it.quantity; }); this.renderList(); }).catch(() => {});
      loadProducts(this.deal).then((data) => { this.data = data; this.renderFilters(); this.renderList(); }).catch(() => { this.q('[data-qp-list]').innerHTML = '<p class="rb-qp__loading">Could not load scents. <a href="/collections/any-8-for-24">Open the builder</a></p>'; });
      this.renderCount();
    }
    position() {
      const sheet = this.q('.rb-qp__sheet');
      const drawer = document.querySelector('cart-drawer');
      if (window.innerWidth >= 750 && drawer && drawer.getBoundingClientRect().width > 0 && drawer.getBoundingClientRect().width < window.innerWidth) {
        const r = drawer.getBoundingClientRect();
        sheet.style.left = r.left + 'px'; sheet.style.width = r.width + 'px'; sheet.style.right = 'auto';
      }
    }
    close() { document.removeEventListener('keydown', this.onKey); this.el.classList.remove('is-open'); setTimeout(() => this.el.remove(), 200); }
    renderFilters() {
      const types = this.q('[data-qp-types]'), fams = this.q('[data-qp-fams]');
      types.innerHTML = this.cfg.types.map((t) => `<button type="button" class="rb-qp__type${this.state.type === t.key ? ' is-active' : ''}" data-type="${t.key}">${t.label}</button>`).join('');
      fams.innerHTML = FAMS.map((f) => `<button type="button" class="rb-qp__fam${this.state.fam === f.key ? ' is-active' : ''}" data-fam="${f.key}">${f.label}</button>`).join('');
      types.querySelectorAll('[data-type]').forEach((b) => b.addEventListener('click', () => { this.state.type = b.dataset.type; this.renderFilters(); this.renderList(); }));
      fams.querySelectorAll('[data-fam]').forEach((b) => b.addEventListener('click', () => { this.state.fam = b.dataset.fam; this.renderFilters(); this.renderList(); }));
    }
    renderCount() {
      const n = this.picks.length, total = this.pool + n;
      const target = this.cfg.tierOf(this.pool + this.need) || this.cfg.tierOf(this.deal === '8for24' ? 8 : 3);
      this.q('[data-qp-count]').textContent = n + '/' + this.need + ' picked · ' + target;
      this.q('[data-qp-bar]').style.width = Math.min(100, Math.round((n / this.need) * 100)) + '%';
      const go = this.q('[data-qp-go]');
      go.disabled = n === 0;
      go.textContent = n === 0 ? 'Pick your scents' : dealCta(n, this.pool, this.cfg);
      go.classList.toggle('is-ready', n >= this.need);
    }
    renderList() {
      if (!this.data) return;
      const { list, rank, best } = this.data;
      const fam = FAMS.find((f) => f.key === this.state.fam);
      const q = this.state.q.trim().toLowerCase();
      let all = list.filter((p) => (this.state.type === 'all' || p.type === this.state.type)
        && (!fam.match.length || (p.fam || []).some((v) => fam.match.indexOf(v) !== -1))
        && (!q || p.name.toLowerCase().indexOf(q) !== -1 || (p.notes || '').toLowerCase().indexOf(q) !== -1));
      all = all.slice().sort(this.state.bestSort ? ((x, y) => rank.get(String(x.id)) - rank.get(String(y.id))) : ((x, y) => x.name.localeCompare(y.name)));
      this.meta.querySelector('[data-qp-n]').textContent = all.length + (all.length === 1 ? ' scent' : ' scents');
      const counts = {}; this.picks.forEach((id) => { counts[id] = (counts[id] || 0) + 1; });
      const listEl = this.q('[data-qp-list]');
      if (!all.length) { listEl.innerHTML = '<p class="rb-qp__loading">No scents found</p>'; return; }
      listEl.innerHTML = all.slice(0, 60).map((p) => {
        const id = String(p.id), n = counts[id] || 0;
        const left = p.max == null ? Infinity : Math.max(0, p.max - (this.inCart[id] || 0)), atCap = n >= left;
        const low = left !== Infinity && left <= 10 ? `<span class="rb-low">${left > 0 ? 'Only ' + left + ' left' : 'Sold out'}</span>` : '';
        const act = n ? `<span class="rb-qp__step"><button type="button" data-minus="${id}" aria-label="Remove one">&minus;</button><span>${n}</span><button type="button" data-plus="${id}" aria-label="Add one"${atCap ? ' disabled' : ''}>+</button></span>` : `<button type="button" class="rb-qp__add" data-plus="${id}"${atCap ? ' disabled' : ''}>${left > 0 ? 'Add' : 'Sold out'}</button>`;
        return `<div class="rb-qp__item${n ? ' is-picked' : ''}"><span class="rb-qp__imgwrap">${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : ''}</span><span class="rb-qp__body"><span class="rb-qp__ty">${best.has(id) ? '<span class="rb-best-tag">Best seller</span>' : ''}${esc(this.cfg.labels[p.type] || '')}</span><span class="rb-qp__nm">${esc(p.name)}</span>${p.notes ? `<span class="rb-qp__nt">${esc(p.notes)}</span>` : ''}${p.reviews ? `<span class="rb-qp__rv"><span aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;</span> ${p.reviews}<span class="sr-only"> reviews</span></span>` : ''}${low}</span>${act}</div>`;
      }).join('');
      listEl.prepend(this.meta);
      listEl.querySelectorAll('[data-plus]').forEach((b) => b.addEventListener('click', () => { this.picks.push(b.dataset.plus); this.renderCount(); this.renderList(); }));
      listEl.querySelectorAll('[data-minus]').forEach((b) => b.addEventListener('click', () => { const i = this.picks.lastIndexOf(b.dataset.minus); if (i > -1) this.picks.splice(i, 1); this.renderCount(); this.renderList(); }));
    }
    async addToCart() {
      if (!this.picks.length) return;
      const go = this.q('[data-qp-go]'); go.disabled = true; go.textContent = 'Adding…';
      const counts = {}; this.picks.forEach((id) => { counts[id] = (counts[id] || 0) + 1; });
      const items = Object.keys(counts).map((id) => ({ id: parseInt(id, 10), quantity: counts[id], properties: { _from: this.cfg.from } }));
      try {
        const res = await post('cart/add.js', { items });
        if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.description || 'Could not add to basket'); }
        await post('cart/update.js', { attributes: { _source: this.cfg.from } }).catch(() => {});
        this.close();
        await refresh();
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function' && !document.querySelector('.rb-bc--page')) { try { drawer.show(); } catch (e) {} }
      } catch (err) {
        const e = this.q('[data-qp-err]'); e.textContent = err.message; e.hidden = false; this.renderCount();
      }
    }
  }
  document.addEventListener('click', (e) => {
    const pick = e.target.closest('[data-rb-pick]');
    if (!pick) return;
    e.preventDefault();
    new RbQuickPicker(parseInt(pick.dataset.rbPick, 10) || 1, parseInt(pick.dataset.pool, 10) || 0, pick.dataset.deal || '8for24');
  });

  /* Message for paid lines taken out because they sold out after being added (drawer note, cart page, builder flash). */
  window.rbLineOOSMsg = () => {
    /* Read by the drawer note and the builder alike; shown for 20s after the removal, then dropped. */
    let l = null;
    try { l = JSON.parse(sessionStorage.getItem('rbLineOOS') || 'null'); } catch (e) {}
    if (!l || !l.n || !l.n.length || Date.now() - l.t > 20000) return '';
    const names = [...new Set(l.n)], many = names.length > 1;
    const list = many ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names[0];
    return list + (many ? ' have' : ' has') + ' sold out since you added ' + (many ? 'them' : 'it') + ', so we\'ve taken ' + (many ? 'them' : 'it') + ' out of your basket. Pick another to keep your deal.';
  };
  class RbGiftSync extends HTMLElement {
    async connectedCallback() {
      const key = this.dataset.key;
      window.__rbGiftRemoving = window.__rbGiftRemoving || {};
      if (!key || window.__rbGiftRemoving[key]) return;
      window.__rbGiftRemoving[key] = true;
      try {
        await post('cart/change.js', { id: key, quantity: parseInt(this.dataset.qty, 10) || 0 });
        if (this.dataset.reason === 'oos') { try { sessionStorage.setItem('rbGiftOOS', '1'); } catch (e) {} }
        if (this.dataset.reason === 'line') { try { let l = JSON.parse(sessionStorage.getItem('rbLineOOS') || 'null'); if (!l || Date.now() - l.t > 20000) l = { n: [] }; l.n.push(this.dataset.name); l.t = Date.now(); sessionStorage.setItem('rbLineOOS', JSON.stringify(l)); } catch (e) {} }
        await refresh();
      } catch (err) {}
    }
  }
  if (!customElements.get('rb-gift-sync')) customElements.define('rb-gift-sync', RbGiftSync);
  /* £35 stock gift slot (snap bars + mini room mists): a random one of the top 5 by stock, kept for the session
     (falls back to the server's highest-stock pick when storage is unavailable). */
  class RbGiftPick extends HTMLElement {
    connectedCallback() {
      try {
        const alts = JSON.parse(this.dataset.alts), k = 'rbGiftStk';
        let p = alts.find((x) => x.h === sessionStorage.getItem(k));
        if (!p) { p = alts[Math.floor(Math.random() * alts.length)]; sessionStorage.setItem(k, p.h); }
        const opt = this.parentElement, img = opt.querySelector('img');
        opt.querySelector('.rb-bc__gift-name').textContent = p.t;
        opt.querySelector('[data-rb-gift]').dataset.rbGift = p.v;
        if (img && p.i) { img.removeAttribute('srcset'); img.src = p.i; }
      } catch (e) {}
    }
  }
  if (!customElements.get('rb-gift-pick')) customElements.define('rb-gift-pick', RbGiftPick);
  /* Shows "your gift sold out" once, after rb-gift-sync removed an out-of-stock gift. */
  class RbGiftNote extends HTMLElement {
    connectedCallback() {
      if (this.dataset.kind === 'line') {
        const msg = window.rbLineOOSMsg && window.rbLineOOSMsg();
        if (msg) { this.querySelector('p').textContent = msg; this.hidden = false; }
        return;
      }
      let flag = null;
      try { flag = sessionStorage.getItem('rbGiftOOS'); } catch (e) {}
      if (!flag) return;
      this.hidden = false;
      try { sessionStorage.removeItem('rbGiftOOS'); } catch (e) {}
      const d = this.parentElement && this.parentElement.querySelector('.rb-bc__gift');
      if (d) d.open = true;
    }
  }
  if (!customElements.get('rb-gift-note')) customElements.define('rb-gift-note', RbGiftNote);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('rb-show-more')) {
    customElements.define('rb-show-more', class extends HTMLElement {
      connectedCallback() {
        if (this._on) return; this._on = true;
        this.per = parseInt(this.dataset.per, 10) || 24; this.shown = this.per;
        this.css = this.querySelector('[data-rb-more-css]'); this.btn = this.querySelector('[data-rb-more]');
        this.list = this.parentElement.querySelector('.product-list');
        this.btn.addEventListener('click', () => this.more());
      }
      async more() {
        if (!this.list || this.busy) return;
        this.shown += this.per;
        if (this.shown > this.list.children.length && this.dataset.next) {
          this.busy = true; this.btn.setAttribute('aria-busy', 'true');
          try {
            const url = new URL(this.dataset.next, location.origin); url.searchParams.set('section_id', this.dataset.section);
            const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
            doc.querySelectorAll('.product-list > product-card').forEach((n) => this.list.appendChild(document.importNode(n, true)));
            const nx = doc.querySelector('rb-show-more'); this.dataset.next = (nx && nx.dataset.next) || '';
          } catch (e) { this.dataset.next = ''; }
          this.busy = false; this.btn.removeAttribute('aria-busy');
        }
        this.css.textContent = '#shopify-section-' + this.dataset.section + ' .product-list > :nth-child(n+' + (this.shown + 1) + ') { display: none; }';
        if (this.shown >= this.list.children.length && !this.dataset.next) this.hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-8-for-24"] && !Shopify.designMode) return;
  try {
    
/* Bundle v2 builder. Pricing ladder matches the Multi-Deal v2 function: the cheapest mix of
   12 for £35, 8 for £24 and £5 singles. Basket items already in the deal show in the slots
   ("in basket") so a customer coming from the cart only picks the rest. */
class Rb8For24 extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    const raw = this.querySelector('[data-rb8-products]');
    if (!raw) { document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true }); return; }
    this._init = true;
    /* One builder, three deals (Multi-Deal v2 prices them; this is display only). */
    const DEALS = {
      '8for24': { size: 8, unit: 5, bundle: 24, from: '8for24-builder', label: '8 for £24', inYour: 'in your 8', note: '£5 each · any 8 for £24 · any 12 for £35',
        types: { snap: 'Snap Bar Wax Melt', carpet: 'Carpet Freshener · 300g', mist: 'Mini Room Mist · 10ml' },
        tabs: [{ key: 'all', label: 'All' }, { key: 'snap', label: 'Snap Bars' }, { key: 'carpet', label: 'Carpet' }, { key: 'mist', label: 'Room Mists' }],
        pills: [{ key: 'carpet', label: 'Carpet Fresheners', short: 'Carpet' }, { key: 'snap', label: 'Snap Bars', short: 'Snap Bars' }, { key: 'mist', label: 'Mini Room Mists', short: 'Minis' }, { key: 'all', label: 'All', short: 'All' }],
        share: { carpet: 4 / 8, snap: 3 / 8, mist: 1 / 8 } },
      '3for35': { size: 3, unit: 16, bundle: 35, from: '3for35-builder', label: '3 for £35', inYour: 'in your 3', note: '£16 each · any 3 reeds or candles for £35',
        types: { reed: 'Reed Diffuser', candle: 'Soy Wax Candle' },
        tabs: [{ key: 'all', label: 'All' }, { key: 'reed', label: 'Reed Diffusers' }, { key: 'candle', label: 'Candles' }],
        pills: [{ key: 'reed', label: 'Reed Diffusers', short: 'Reeds' }, { key: 'candle', label: 'Candles', short: 'Candles' }, { key: 'all', label: 'All', short: 'All' }],
        share: { reed: 2 / 3, candle: 1 / 3 } },
      '3for30': { size: 3, unit: 12, bundle: 30, from: '3for30-builder', label: '3 for £30', inYour: 'in your 3', note: '£12 each · any 3 room mists for £30',
        types: { rs: 'Room Mist · 100ml' },
        tabs: [{ key: 'all', label: 'All' }], pills: [], share: { rs: 1 } }
    };
    this.deal = DEALS[this.dataset.deal] ? this.dataset.deal : '8for24';
    this.D = DEALS[this.deal];
    this.unitFull = this.D.unit;
    this.RENDER_CAP = 60;
    this.TIERS = [{ v: 35, label: 'Free gift', next: 'a <strong>free gift</strong>' }, { v: 50, label: 'Free delivery', next: '<strong>free tracked delivery</strong>' }, { v: 60, label: 'Bigger gift', next: 'a <strong>free reed diffuser or room mist</strong>' }];
    this.state = { picks: [], tab: (this.dataset.preset && this.D.tabs.some((t) => t.key === this.dataset.preset)) ? this.dataset.preset : 'all', fam: 'all', query: '', bestSort: true };
    this.basket = []; this.cartSpend = 0;

    try { this.products = JSON.parse(raw.textContent) || []; } catch (e) { this.products = []; }
    this.byId = new Map(this.products.map((p) => [String(p.id), p]));
    const ranked = this.products.slice().sort((x, y) => (y.reviews || 0) - (x.reviews || 0));
    this.rank = new Map(ranked.map((p, i) => [String(p.id), i]));
    this.bestIds = new Set(ranked.slice(0, 12).filter((p) => (p.reviews || 0) > 0).map((p) => String(p.id)));
    /* Picks not yet in the basket survive a reload or a return visit in the same session (Craig, 7 Oct 2026).
       The list only holds in-stock items, so a saved pick missing from it has sold out since: drop it and say so. */
    this.pickKey = 'rb8picks:' + this.deal;
    const gone = [], seen = {};
    try {
      (JSON.parse(sessionStorage.getItem(this.pickKey) || '[]')).forEach(([id, nm]) => {
        const p = this.byId.get(String(id)); seen[id] = (seen[id] || 0) + 1;
        if (p && (p.max == null || seen[id] <= p.max)) this.state.picks.push(String(id)); else if (!gone.includes(nm)) gone.push(nm);
      });
    } catch (e) {}
    this.restoreMsg = gone.length ? gone.join(', ') + (gone.length > 1 ? ' have' : ' has') + ' sold out since you picked ' + (gone.length > 1 ? 'them' : 'it') + ', so we\'ve taken ' + (gone.length > 1 ? 'them' : 'it') + ' out of your bundle.' : '';

    this.typeLabels = this.D.types;
    this.tabDefs = this.D.tabs;
    this.famDefs = [
      { key: 'all', label: 'All scents', match: [] },
      { key: 'fresh', label: 'Fresh & clean', match: ['Fresh', 'Laundry', 'Spa'] },
      { key: 'fruity', label: 'Fruity', match: ['Fruity'] },
      { key: 'sweet', label: 'Sweet', match: ['Sweet', 'Bakery'] },
      { key: 'floral', label: 'Floral', match: ['Floral', 'Lavender'] },
      { key: 'warm', label: 'Warm & cosy', match: ['Autumn', 'Oud'] },
      { key: 'perfume', label: 'Perfume-inspired', match: ['Perfume', 'Inspired By', 'Aftershave'] }
    ];

    const q = (sel) => this.querySelector(sel);
    this.slotsEl = q('[data-slots]'); this.extrasWrap = q('[data-extras-wrap]'); this.extrasEl = q('[data-extras]'); this.extrasLabel = q('[data-extras-label]');
    this.countLabel = q('[data-count-label]'); this.progressMsg = q('[data-progress-msg]'); this.progressBar = q('[data-progress-bar]');
    this.fullPriceEl = q('[data-fullprice]'); this.payEl = q('[data-pay]'); this.savingEl = q('[data-saving]');
    this.atc = q('[data-atc]'); this.atcErr = q('[data-atc-err]'); this.atcNote = q('[data-atc-note]'); this.tiersEl = q('[data-tiers]');

    const tpl = q('[data-drawer-template]');
    const frag = tpl.content.cloneNode(true);
    this.overlay = frag.querySelector('[data-overlay]');
    document.body.appendChild(frag);
    const o = (sel) => this.overlay.querySelector(sel);
    this.drawerProgress = o('[data-drawer-progress]'); this.drawerList = o('[data-drawer-list]'); this.drawerTabs = o('[data-drawer-tabs]');
    this.drawerFams = o('[data-drawer-fams]'); this.drawerCount = o('[data-drawer-count]'); this.drawerSort = o('[data-drawer-sort]');
    this.drawerSearch = o('[data-drawer-search]'); this.drawerNote = o('[data-drawer-note]'); this.drawerDone = o('[data-drawer-done]');
    this.drawerErr = o('[data-drawer-err]'); this.drawerBanner = o('[data-drawer-banner]');

    this.infoPop = document.createElement('div'); this.infoPop.className = 'rb8-pop'; this.infoPop.hidden = true; this.overlay.appendChild(this.infoPop);

    this.fillDealCards();
    this.bind();
    this.renderTabs();
    this.render();
    this.loadBasket();
  }

  money(n) { return '£' + Math.abs(n).toFixed(2); }
  tierOf(n) { if (this.D.size === 3) return n >= 3 ? this.D.label : ''; return n >= 12 ? '12 for £35' : (n >= 8 ? '8 for £24' : ''); }
  /* next count that completes a deal step: 8 → 12 for the £5 pool, the next multiple of 3 for trios (0 = nothing pending) */
  target(t) { if (this.D.size === 3) return t < 3 ? 3 : (t % 3 ? t + 3 - (t % 3) : 0); return t < 8 ? 8 : (t < 12 ? 12 : 0); }
  each(n) { if (this.D.size === 3) return n >= 3 ? this.money(this.D.bundle / 3) : this.money(this.D.unit); return n >= 12 ? '£2.92' : '£3.00'; }
  /* CTA copy by basket delta: finishing a deal can make the basket cheaper, so never show a negative price. */
  ctaLabel(n, base) {
    const d = Math.round((this.price(base + n) - this.price(base)) * 100) / 100;
    const t = this.tierOf(base + n), newTier = t && t !== this.tierOf(base);
    if (base === 0) return 'Add ' + n + ' to basket · ' + this.money(d);
    if (d < 0) return 'Add ' + n + ' & save ' + this.money(d) + (t ? ' · ' + t : '');
    if (d === 0) return 'Add ' + n + ' at no extra cost' + (t ? ' · ' + t : '');
    return 'Add ' + n + ' · +' + this.money(d) + (newTier ? ' → ' + t : '');
  }
  updateSticky() {
    if (!this.sticky) return;
    const on = !this.atcVisible && !(this.overlay && this.overlay.classList.contains('is-open'));
    this.sticky.classList.toggle('is-on', on);
    this.sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.documentElement.classList.toggle('rb8-sticky-on', on);
  }
  short(n) { return this.money(n).replace('.00', ''); }
  price(n) { if (this.D.size === 3) return Math.floor(n / 3) * this.D.bundle + (n % 3) * this.D.unit; let best = n * this.unitFull; for (let a = 0; a * 12 <= n; a++) for (let b = 0; a * 12 + b * 8 <= n; b++) { const p = a * 35 + b * 24 + (n - a * 12 - b * 8) * this.unitFull; if (p < best) best = p; } return best; }
  basketCount() { return this.basket.reduce((t, b) => t + b.qty, 0); }

  async syncCart() {
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const sections = ['cart-drawer', 'cart-count'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const cart = await (await fetch(root + 'cart.js', { cache: 'no-store' })).json();
      cart.sections = await (await fetch(root + '?sections=' + sections.join(','), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' })).json();
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
    } catch (e) {}
    await this.loadBasket();
  }
  async loadBasket() {
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cart = await (await fetch(root + 'cart.js', { cache: 'no-store' })).json();
      /* Tier spend = items after the 8/12 deal, BEFORE discount codes, gifts and shipping excluded (Craig, 5 Oct). */
      let spend = 0;
      this.basket = [];
      cart.items.forEach((it) => {
        const isGift = it.properties && it.properties._gift;
        if (isGift) return;
        const deal = (it.line_level_discount_allocations || []).filter((a) => /multi-deal|mdtest/i.test((a.discount_application && a.discount_application.title) || '')).reduce((t, a) => t + a.amount, 0);
        spend += it.original_line_price - deal;
        if (it.selling_plan_allocation) return;
        if (this.byId.has(String(it.variant_id))) this.basket.push({ id: String(it.variant_id), qty: it.quantity });
      });
      this.cartSpend = spend / 100;
      this.render();
      const qty = {}; cart.items.forEach((it) => { if (!(it.properties && it.properties._gift)) qty[String(it.variant_id)] = (qty[String(it.variant_id)] || 0) + it.quantity; });
      document.querySelectorAll('[data-rb-deal-add]').forEach((b) => {
        const n = qty[b.dataset.rbDealAdd] || 0;
        b.textContent = n ? (n + ' ' + this.D.inYour + ' · add') : ('Add to my ' + this.D.size);
        b.classList.toggle('rb-dealadd--in', n > 0);
      });
    } catch (e) {}
  }

  fillDealCards() {
    this.querySelectorAll('[data-deal-type]').forEach((card) => {
      const p = this.products.find((x) => x.type === card.dataset.dealType && x.image);
      const slot = card.querySelector('.rb8__deal-img');
      if (p && slot) slot.innerHTML = `<img src="${this.escapeAttr(p.image)}" alt="" loading="lazy">`;
    });
  }

  slotHtml(p, opts) {
    const img = p.image ? `<img class="rb8-slot__img" src="${this.escapeAttr(p.image)}" alt="" loading="lazy">` : '';
    if (opts.basket) return `<div class="rb8-slot rb8-slot--filled rb8-slot--basket">${img}<span class="rb8-slot__name">${this.escape(p.name)}</span><span class="rb8-slot__tag">In basket</span></div>`;
    return `<div class="rb8-slot rb8-slot--filled">${img}<span class="rb8-slot__name">${this.escape(p.name)}</span><button type="button" class="rb8-slot__x" data-remove-at="${opts.index}" aria-label="Remove"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 18 18 6M6 6l12 12"></path></svg></button></div>`;
  }

  counts() { const c = {}; this.state.picks.forEach((id) => { c[id] = (c[id] || 0) + 1; }); return c; }
  inBasketOf(id) { return this.basket.filter((b) => b.id === String(id)).reduce((t, b) => t + b.qty, 0); }
  /* Stock cap: tracked, deny-policy variants can't be picked past what is left (minus what is already in the basket). */
  leftOf(id) { const p = this.byId.get(String(id)); if (!p || p.max == null) return Infinity; return Math.max(0, p.max - this.inBasketOf(id)); }
  add(id) {
    id = String(id);
    const n = this.state.picks.filter((x) => x === id).length;
    if (n >= this.leftOf(id)) { this.flash(this.stockMsg(id, this.leftOf(id))); return; }
    this.state.picks = this.state.picks.concat([id]); this.render();
  }
  stockMsg(id, left) { const p = this.byId.get(String(id)); const nm = p ? p.name : 'that scent'; return left > 0 ? ('Only ' + left + ' ' + nm + ' left, so that is the most you can add.') : ('Sorry, ' + nm + ' has just sold out.'); }
  flash(msg) {
    [this.atcErr, this.drawerErr].forEach((el) => { if (el) { el.textContent = msg; el.hidden = false; } });
    clearTimeout(this._flashT); this._flashT = setTimeout(() => [this.atcErr, this.drawerErr].forEach((el) => { if (el) el.hidden = true; }), 8000);
  }
  removeAt(i) { this.state.picks = this.state.picks.filter((_, idx) => idx !== i); this.render(); }
  removeLastOf(id) { const n = this.state.picks.slice(); for (let i = n.length - 1; i >= 0; i--) { if (n[i] === String(id)) { n.splice(i, 1); break; } } this.state.picks = n; this.render(); }

  /* Fill the open slots with a best-seller MIX: target share 4 carpet / 3 snap / 1 mini per 8 (order penetration:
     CF ~68% of orders, snaps ~36%, minis ~19%). Each slot goes to the type furthest below its share, counting what is
     already in the basket and picked; within a type, best sellers (reviews) first, in stock only, and no scent name
     repeated across types where possible. */
  fillBest() {
    const total = this.basketCount() + this.state.picks.length;
    const target = this.target(total) || total;
    let need = target - total;
    if (need <= 0) return;
    const SHARE = this.D.share;
    const have = {}; Object.keys(SHARE).forEach((t) => { have[t] = 0; });
    const names = new Set();
    const count = (id, n) => { const p = this.byId.get(String(id)); if (!p) return; if (have[p.type] != null) have[p.type] += n; names.add(p.name.toLowerCase()); };
    this.basket.forEach((b) => count(b.id, b.qty));
    this.state.picks.forEach((id) => count(id, 1));
    const used = new Set(this.state.picks.concat(this.basket.map((b) => b.id)));
    const byType = {};
    Object.keys(SHARE).forEach((t) => { byType[t] = this.products.filter((p) => p.type === t && !used.has(String(p.id)) && this.leftOf(p.id) > 0).sort((x, y) => (y.reviews || 0) - (x.reviews || 0)); });
    const add = [];
    while (need > 0) {
      const filled = Object.keys(have).reduce((t, k) => t + have[k], 0) + 1;
      const order = Object.keys(SHARE).filter((t) => byType[t].length).sort((x, y) => (have[x] - SHARE[x] * filled) - (have[y] - SHARE[y] * filled));
      if (!order.length) break;
      const t = order[0];
      let i = byType[t].findIndex((p) => !names.has(p.name.toLowerCase()));
      if (i < 0) i = 0;
      const p = byType[t].splice(i, 1)[0];
      add.push(String(p.id)); have[t] += 1; names.add(p.name.toLowerCase()); need--;
    }
    this.state.picks = this.state.picks.concat(add);
    this.render();
  }


  bind() {
    this.querySelectorAll('[data-open-drawer]').forEach((b) => b.addEventListener('click', () => this.openDrawer()));
    this.querySelectorAll('[data-fill-best]').forEach((b) => b.addEventListener('click', () => this.fillBest()));
    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) { this.closeDrawer(); return; }
      if (this.infoPop && !this.infoPop.hidden && !e.target.closest('.rb8-pop') && !e.target.closest('.rb8-di__info')) this.hideInfo();
    });
    this.overlay.querySelector('[data-drawer-close]').addEventListener('click', () => this.closeDrawer());
    this.drawerDone.addEventListener('click', () => { if (this.state.picks.length) this.addToCart(); else this.closeDrawer(); });
    this.drawerSearch.addEventListener('input', () => { this.state.query = this.drawerSearch.value; this.renderDrawer(); });
    this.drawerSort.addEventListener('click', () => { this.state.bestSort = !this.state.bestSort; this.drawerSort.setAttribute('aria-pressed', String(this.state.bestSort)); this.drawerSort.textContent = this.state.bestSort ? 'Sort: Best sellers' : 'Sort: A to Z'; this.renderDrawer(); });
    this.drawerList.addEventListener('scroll', () => this.hideInfo());
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (this.infoPop && !this.infoPop.hidden) { this.hideInfo(); return; }
      if (this.overlay.classList.contains('is-open')) this.closeDrawer();
    });
    this.atc.addEventListener('click', () => { if (this.state.picks.length) this.addToCart(); else this.openDrawer(); });
    this.sticky = this.querySelector('[data-rb8-sticky]');
    if (this.sticky) {
      this.stickyLabel = this.sticky.querySelector('[data-sticky-label]'); this.stickyBar = this.sticky.querySelector('[data-sticky-bar]'); this.stickyBtn = this.sticky.querySelector('[data-sticky-btn]');
      this.stickyBtn.addEventListener('click', () => { if (this.state.picks.length) this.addToCart(); else this.openDrawer(); });
      this.atcVisible = false;
      if ('IntersectionObserver' in window) new IntersectionObserver((en) => { this.atcVisible = en[0].isIntersecting; this.updateSticky(); }).observe(this.atc);
      this.updateSticky();
    }
    document.addEventListener('cart:change', () => {
      this.loadBasket();
      /* A basket item sold out since it was added and the cart drawer took it out: say so above the slots. */
      const m = window.rbLineOOSMsg && window.rbLineOOSMsg(), n = this.querySelector('[data-rb8-oos]');
      if (m && n) { n.textContent = m; n.hidden = false; }
    });
    const rn = this.querySelector('[data-rb8-oos]');
    if (this.restoreMsg && rn) { rn.textContent = this.restoreMsg; rn.hidden = false; }
  }

  openDrawer() { this.overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; this.renderDrawer(); this.updateSticky(); setTimeout(() => this.drawerSearch.focus(), 100); }
  closeDrawer() { this.overlay.classList.remove('is-open'); document.body.style.overflow = ''; this.updateSticky(); }

  dealMsg(total) {
    if (this.D.size === 3) {
      if (total === 0) return 'Pick any 3 to unlock ' + this.D.label;
      const t = this.target(total);
      if (t) { const r = t - total; return 'Add ' + r + ' more to unlock ' + (total >= 3 ? 'another ' : '') + this.D.label; }
      return (total / 3 > 1 ? (total / 3) + ' × ' : '') + this.D.label + ' unlocked';
    }
    if (total === 0) return 'Pick 8 items to unlock 8 for £24';
    if (total < 8) { const r = 8 - total; return 'Add ' + r + ' more ' + (r === 1 ? 'item' : 'items') + ' to unlock 8 for £24'; }
    if (total === 8) return '8 for £24 unlocked. Go to 12 for £35?';
    if (total < 12) { const r = 12 - total; return 'Add ' + r + ' more and get 12 for £35'; }
    if (total === 12) return '12 for £35 unlocked';
    return total + ' items at the best bundle price';
  }

  renderTiers(spend) {
    if (!this.tiersEl) return;
    const next = this.TIERS.find((t) => spend < t.v);
    const head = next ? `Spend ${this.money(next.v - spend)} to unlock ${next.next}` : `You've unlocked every reward`;
    let lo = 0;
    const segs = this.TIERS.map((t) => {
      const fill = Math.max(0, Math.min(100, Math.round(((spend - lo) / (t.v - lo)) * 100)));
      lo = t.v;
      const done = fill >= 100;
      return `<div class="rb-bc__seg${done ? ' is-done' : ''}"><span class="rb-bc__seg-top">${done ? '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-label="Unlocked"><path d="M5 12l4 4 10-10"></path></svg>' : '£' + t.v + ' &middot; '}<span class="rb-bc__seg-label">${t.label}</span></span><span class="rb-bc__track"><span class="rb-bc__fill" style="width:${fill}%"></span></span></div>`;
    }).join('');
    this.tiersEl.innerHTML = `<div class="rb-bc"><p class="rb-bc__headline">${head}</p><div class="rb-bc__segs">${segs}</div></div>`;
  }

  render() {
    const picks = this.state.picks;
    try { if (picks.length) sessionStorage.setItem(this.pickKey, JSON.stringify(picks.map((id) => { const p = this.byId.get(id) || {}; return [id, p.name + ' ' + String(this.typeLabels[p.type] || '').split(' · ')[0]]; }))); else sessionStorage.removeItem(this.pickKey); } catch (e) {}
    const inBasket = this.basketCount();
    const total = inBasket + picks.length;
    const slotsN = this.D.size === 3 ? Math.max(3, this.target(total) || total) : (total < 8 ? 8 : (total <= 12 ? 12 : total));
    const mainN = this.D.size === 3 ? slotsN : 8;

    const items = [];
    this.basket.forEach((b) => { const p = this.byId.get(b.id); for (let i = 0; i < b.qty && p; i++) items.push({ p, basket: true }); });
    picks.forEach((id, index) => { const p = this.byId.get(id); if (p) items.push({ p, index }); });

    let html = '';
    for (let i = 0; i < Math.min(slotsN, mainN); i++) {
      const it = items[i];
      html += it ? this.slotHtml(it.p, it) : `<div class="rb8-slot rb8-slot--empty" data-open-slot><span class="rb8-slot__num">${i + 1}</span></div>`;
    }
    this.slotsEl.innerHTML = html;
    if (slotsN > mainN) {
      let ex = '';
      for (let i = mainN; i < slotsN; i++) { const it = items[i]; ex += it ? this.slotHtml(it.p, it) : `<div class="rb8-slot rb8-slot--empty" data-open-slot><span class="rb8-slot__num">${i + 1}</span></div>`; }
      this.extrasWrap.hidden = false; this.extrasEl.innerHTML = ex;
      if (this.extrasLabel) this.extrasLabel.textContent = total >= 12 ? '12 for £35 unlocked' : 'Items 9 to 11 are £5 each. Fill all 12 for £35.';
    } else { this.extrasWrap.hidden = true; this.extrasEl.innerHTML = ''; }

    this.querySelectorAll('[data-open-slot]').forEach((el) => el.addEventListener('click', () => this.openDrawer()));
    this.querySelectorAll('[data-remove-at]').forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); this.removeAt(parseInt(b.dataset.removeAt, 10)); }));

    const full = total * this.unitFull;
    const bundle = this.price(total);
    const addCost = this.price(total) - this.price(inBasket);
    const saving = full - bundle;

    const tg = this.target(total);
    this.countLabel.textContent = total + (total === 1 ? ' item' : ' items') + (inBasket ? ' (' + inBasket + ' in basket)' : '') + ' · ' + (tg ? (total + ' of ' + tg) : 'deal unlocked');
    this.progressMsg.textContent = this.dealMsg(total);
    this.progressBar.style.width = (tg ? Math.min(100, Math.round((total / tg) * 100)) : 100) + '%';
    this.fullPriceEl.textContent = total === 0 ? 'Every item ' + this.money(this.D.unit).replace('.00', '') : this.money(full);
    this.fullPriceEl.classList.toggle('is-through', saving > 0);
    this.payEl.textContent = total === 0 ? (this.money(this.D.bundle) + ' for ' + this.D.size) : this.money(bundle);
    this.savingEl.textContent = saving > 0 ? ('You save ' + this.money(saving)) : (total < this.D.size ? 'Full price until you reach ' + this.D.size : '');

    if (picks.length) {
      this.atc.classList.add('is-ready'); this.atc.disabled = false;
      this.atc.textContent = this.ctaLabel(picks.length, inBasket);
    } else {
      this.atc.classList.remove('is-ready'); this.atc.disabled = true;
      this.atc.textContent = inBasket ? 'Pick more scents' : 'Pick your scents';
    }
    if (this.atcNote) this.atcNote.textContent = this.D.size === 3 ? (tg ? ('Pick ' + (tg - total) + ' more and pay ' + this.money(this.price(tg)) + ' for ' + tg + '. The discount applies automatically, no code.') : 'The discount applies automatically, no code.') : (total < 8 ? ('Or pick ' + (8 - total) + ' more and pay £24 for all 8. The discount applies automatically, no code.') : (total < 12 ? ('Add ' + (12 - total) + ' more and pay £35 for 12.') : 'The discount applies automatically, no code.'));

    if (this.sticky) {
      const tgt = tg;
      this.stickyLabel.textContent = total === 0 ? ('Any ' + this.D.label) : ((total < this.D.size ? total + ' of ' + this.D.size : total + ' picked') + ' · ' + this.money(bundle));
      this.stickyBar.style.width = (tgt ? Math.min(100, Math.round((total / tgt) * 100)) : 100) + '%';
      this.stickyBtn.textContent = picks.length ? this.ctaLabel(picks.length, inBasket) : (inBasket ? (tg ? 'Pick ' + (tg - total) + ' more → ' + this.tierOf(tg) : 'Pick more') : ('Pick any ' + this.D.label));
      this.stickyBtn.classList.toggle('is-ready', picks.length > 0);
    }
    this.renderTiers(this.cartSpend + addCost);
    this.renderPills();
    if (this.overlay.classList.contains('is-open')) this.renderDrawer();
  }

  /* Collection pages: range pills above the slots open the picker on that range. */
  renderPills() {
    const el = this.querySelector('[data-type-pills]');
    if (!el || !this.D.pills.length) return;
    if (!el.dataset.built) {
      el.dataset.built = '1';
      el.style.setProperty('--rb8-pills', this.D.pills.length);
      el.innerHTML = this.D.pills.map((t) => `<button type="button" class="rb8__pill" data-pill="${t.key}" aria-pressed="false" aria-label="${t.label}"><span class="rb8__pill-long">${t.label}</span><span class="rb8__pill-short" aria-hidden="true">${t.short || t.label}</span></button>`).join('');
      el.querySelectorAll('[data-pill]').forEach((b) => b.addEventListener('click', () => { this.state.tab = b.dataset.pill; this.renderTabs(); this.renderPills(); this.openDrawer(); }));
    }
    el.querySelectorAll('[data-pill]').forEach((b) => { const on = b.dataset.pill === this.state.tab; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }

  renderTabs() {
    this.drawerTabs.innerHTML = this.tabDefs.map((t) => `<button type="button" class="rb8-drawer__tab${this.state.tab === t.key ? ' is-active' : ''}" data-tab="${t.key}">${t.label}</button>`).join('');
    this.drawerTabs.querySelectorAll('[data-tab]').forEach((b) => b.addEventListener('click', () => { this.state.tab = b.dataset.tab; this.renderTabs(); this.renderDrawer(); }));
    this.drawerFams.innerHTML = this.famDefs.map((f) => `<button type="button" class="rb8-fam__tab${this.state.fam === f.key ? ' is-active' : ''}" data-fam="${f.key}">${f.label}</button>`).join('');
    this.drawerFams.querySelectorAll('[data-fam]').forEach((b) => b.addEventListener('click', () => { this.state.fam = b.dataset.fam; this.renderTabs(); this.renderDrawer(); }));
  }

  renderDrawer() {
    this.hideInfo();
    const inBasket = this.basketCount();
    const total = inBasket + this.state.picks.length;
    const addCost = this.price(total) - this.price(inBasket);
    const dtg = this.target(total);
    this.drawerProgress.textContent = dtg ? (total + ' of ' + dtg + ' · ' + (dtg - total) + ' more for ' + this.money(this.price(dtg)).replace('.00', '')) : (total + ' picked · deal unlocked');
    if (this.drawerBanner) { this.drawerBanner.hidden = total < this.D.size; this.drawerBanner.textContent = this.D.size === 3 ? (dtg ? this.D.label + ' unlocked. Add ' + (dtg - total) + ' more for another.' : this.D.label + ' unlocked.') : (total >= 12 ? '12 for £35 unlocked.' : (total >= 8 ? '8 for £24 unlocked. Add ' + (12 - total) + ' more for 12 for £35.' : '')); }
    this.drawerNote.textContent = this.D.note;
    this.drawerDone.textContent = this.state.picks.length ? this.ctaLabel(this.state.picks.length, this.basketCount()) : 'Done';
    this.drawerDone.classList.toggle('rb8-drawer__done--go', this.state.picks.length > 0);

    const q = this.state.query.trim().toLowerCase();
    const fam = this.famDefs.find((f) => f.key === this.state.fam);
    const cnts = this.counts();
    let all = this.products.filter((p) => {
      if (this.state.tab !== 'all' && p.type !== this.state.tab) return false;
      if (fam && fam.match.length && !(p.fam || []).some((v) => fam.match.indexOf(v) !== -1)) return false;
      if (q && p.name.toLowerCase().indexOf(q) === -1 && (p.notes || '').toLowerCase().indexOf(q) === -1) return false;
      return true;
    });
    if (this.state.bestSort) all = all.slice().sort((x, y) => this.rank.get(String(x.id)) - this.rank.get(String(y.id)));
    else all = all.slice().sort((x, y) => x.name.localeCompare(y.name));
    if (this.drawerCount) this.drawerCount.textContent = all.length + (all.length === 1 ? ' scent' : ' scents');

    if (!all.length) { this.drawerList.innerHTML = '<p class="rb8-drawer__none">No scents found</p>'; return; }
    const shown = all.slice(0, this.RENDER_CAP);
    const cards = shown.map((p) => {
      const n = cnts[String(p.id)] || 0;
      const best = this.bestIds.has(String(p.id));
      const left = this.leftOf(p.id), atCap = n >= left;
      const low = left !== Infinity && left <= 10 ? `<span class="rb-low">${left > 0 ? 'Only ' + left + ' left' : 'Sold out'}</span>` : '';
      const img = p.image ? `<span class="rb8-di__imgwrap"><img class="rb8-di__img" src="${this.escapeAttr(p.image)}" alt="${this.escapeAttr(p.name)}" loading="lazy"></span>` : `<span class="rb8-di__img"></span>`;
      const act = n > 0
        ? `<div class="rb8-di__step"><button type="button" class="rb8-di__stepbtn" data-minus="${p.id}" aria-label="Remove one"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"></path></svg></button><span class="rb8-di__stepn">${n}</span><button type="button" class="rb8-di__stepbtn" data-plus="${p.id}" aria-label="Add one"${atCap ? ' disabled' : ''}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"></path></svg></button></div>`
        : `<button type="button" class="rb8-di__add" data-add="${p.id}"${atCap ? ' disabled' : ''}>Add</button>`;
      const rev = p.reviews ? `<span class="rb8-di__rev"><span class="rb8__stars" aria-hidden="true">&#9733;&#9733;&#9733;&#9733;&#9733;</span> ${p.reviews} reviews</span>` : '';
      return `<div class="rb8-di${n > 0 ? ' is-picked' : ''}">${img}<span class="rb8-di__body"><span class="rb8-di__type">${best ? '<span class="rb-best-tag">Best seller</span>' : ''}${this.escape(this.typeLabels[p.type] || '')}</span><span class="rb8-di__namerow"><span class="rb8-di__name">${this.escape(p.name)}</span>${p.desc ? `<button type="button" class="rb8-di__info" data-info="${p.id}" aria-label="Full scent description"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M12 11.5v4.5"></path><path d="M12 8h.01"></path></svg></button>` : ''}</span>${p.notes ? `<span class="rb8-di__notes">${this.escape(p.notes)}</span>` : ''}${rev}${low}<span class="rb8-di__price"><span class="rb8-di__was">${this.money(this.unitFull)}</span><span class="rb8-di__now">${this.each(Math.max(this.D.size, this.basketCount() + this.state.picks.length))} ${this.D.inYour}</span></span></span><span class="rb8-di__act">${act}</span></div>`;
    }).join('');
    const more = all.length > shown.length ? `<p class="rb8-drawer__more">Showing ${shown.length} of ${all.length}. Search or use the filters to narrow it down.</p>` : '';
    this.drawerList.innerHTML = `<div class="rb8-drawer__grid">${cards}</div>${more}`;
    this.drawerList.querySelectorAll('[data-add]').forEach((b) => b.addEventListener('click', () => this.add(b.dataset.add)));
    this.drawerList.querySelectorAll('[data-plus]').forEach((b) => b.addEventListener('click', () => this.add(b.dataset.plus)));
    this.drawerList.querySelectorAll('[data-minus]').forEach((b) => b.addEventListener('click', () => this.removeLastOf(b.dataset.minus)));
    this.drawerList.querySelectorAll('[data-info]').forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); this.showInfo(b.dataset.info, b); }));
  }

  showInfo(id, btn) {
    const p = this.byId.get(String(id));
    if (!p || !p.desc || !this.infoPop) return;
    this.infoPop.textContent = p.desc;
    const pw = Math.min(280, window.innerWidth - 24);
    this.infoPop.style.maxWidth = pw + 'px';
    this.infoPop.hidden = false;
    const r = btn.getBoundingClientRect();
    this.infoPop.style.left = Math.max(12, Math.min(r.left, window.innerWidth - pw - 12)) + 'px';
    this.infoPop.style.top = (r.bottom + 8) + 'px';
    const ph = this.infoPop.getBoundingClientRect().height;
    if (r.bottom + 8 + ph > window.innerHeight - 12) this.infoPop.style.top = Math.max(12, r.top - 8 - ph) + 'px';
  }
  hideInfo() { if (this.infoPop) this.infoPop.hidden = true; }

  async addToCart() {
    if (!this.state.picks.length) return;
    const cnts = this.counts();
    const before = {}; Object.keys(cnts).forEach((id) => { before[id] = this.inBasketOf(id); });
    let failMsg = '';
    // Hidden _from property tags each line as coming from this builder (order tagging / Klaviyo).
    const items = Object.keys(cnts).map((id) => ({ id: parseInt(id, 10), quantity: cnts[id], properties: { _from: this.D.from } }));
    const drawerOpen = this.overlay.classList.contains('is-open');
    this.atc.setAttribute('aria-busy', 'true'); this.atc.disabled = true;
    if (this.atcErr) this.atcErr.hidden = true;
    if (this.drawerErr) this.drawerErr.hidden = true;
    if (drawerOpen && this.drawerDone) { this.drawerDone.setAttribute('aria-busy', 'true'); this.drawerDone.disabled = true; this.drawerDone.textContent = 'Adding…'; }
    try {
      const root = window.Shopify.routes.root;
      const sections = ['cart-drawer', 'cart-count'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items }) });
      if (!res.ok) { const err = await res.json().catch(() => ({})); failMsg = err.description || 'Could not add to cart'; throw new Error(failMsg); }
      await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ attributes: { _source: this.D.from } }) }).catch(() => {});
      const added = await res.json();
      const cart = await (await fetch(`${root}cart.js`)).json();
      cart.sections = await (await fetch(`${root}?sections=${sections.join(',')}`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })).json();
      this.state.picks = [];
      this.closeDrawer();
      this.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: Array.isArray(added.items) ? added.items : [added], cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
      await this.loadBasket();
      /* Shopify can clamp a line to stock and still return 200: say which scent was short. */
      const clamped = Object.keys(cnts).map((id) => ({ id, got: this.inBasketOf(id) - (before[id] || 0), want: cnts[id] })).filter((x) => x.got < x.want);
      if (clamped.length) this.flash(clamped.map((x) => { const p = this.byId.get(x.id); const nm = p ? p.name : 'that scent'; return x.got > 0 ? ('Only ' + x.got + ' ' + nm + ' left, so we added ' + x.got + '.') : ('Sorry, ' + nm + ' has just sold out.'); }).join(' '));
    } catch (e) {
      /* Partial adds (stock) still change the cart: re-sync everything, then say which scent was short. */
      await this.syncCart();
      const short = Object.keys(cnts).map((id) => ({ id, got: this.inBasketOf(id) - (before[id] || 0), want: cnts[id] })).filter((x) => x.got < x.want);
      if (short.length) this.state.picks = this.state.picks.filter((id) => !short.some((x) => x.id === id));
      const added = Object.keys(cnts).reduce((t, id) => t + Math.max(0, this.inBasketOf(id) - (before[id] || 0)), 0);
      if (added > 0) this.state.picks = [];
      const msg = short.length ? short.map((x) => { const p = this.byId.get(x.id); const nm = p ? p.name : 'that scent'; return x.got > 0 ? ('Only ' + x.got + ' ' + nm + ' left, so we added ' + x.got + '.') : ('Sorry, ' + nm + ' has just sold out.'); }).join(' ') : ((e && e.message) || 'Something went wrong. Please try again.');
      if (this.atcErr) { this.atcErr.textContent = msg; this.atcErr.hidden = false; }
      if (drawerOpen && this.drawerErr) { this.drawerErr.textContent = msg; this.drawerErr.hidden = false; }
    } finally {
      this.atc.removeAttribute('aria-busy');
      if (this.drawerDone) { this.drawerDone.removeAttribute('aria-busy'); this.drawerDone.disabled = false; }
      this.render();
    }
  }

  escape(s) { const d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  escapeAttr(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
}
if (!customElements.get('rb-8for24')) customElements.define('rb-8for24', Rb8For24);
/* Collection grid cards on deal collections: "Add to my 8 / 3" adds one to the basket (tagged as a builder line) and
   the builder at the top of the page re-syncs, so the item shows in its slots. */
document.addEventListener('click', async (e) => {
  const b = e.target.closest('[data-rb-deal-add]');
  if (!b || b.disabled) return;
  e.preventDefault();
  const builder = document.querySelector('rb-8for24');
  const from = builder && builder.D ? builder.D.from : (b.dataset.deal === '8' ? '8for24-builder' : b.dataset.deal + '-builder');
  b.disabled = true; b.setAttribute('aria-busy', 'true');
  try {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: parseInt(b.dataset.rbDealAdd, 10), quantity: 1, properties: { _from: from } }] }) });
    if (!res.ok) { const er = await res.json().catch(() => ({})); b.textContent = er.description || 'Sold out'; return; }
    if (builder && builder.syncCart) await builder.syncCart();
  } catch (err) {} finally { b.disabled = false; b.removeAttribute('aria-busy'); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-8-grid"] && !Shopify.designMode) return;
  try {
    
/* Build your 8 for £24. Prices exactly as the Multi-Deal v2 function (display only). */
class Rb8Grid extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;
    const q = (s) => this.querySelector(s);
    this.cards = Array.from(this.querySelectorAll('.rb8g-card'));
    this.byId = new Map();
    this.cards.forEach((c, i) => {
      const max = c.dataset.max === '' ? null : parseInt(c.dataset.max, 10);
      this.byId.set(c.dataset.id, { id: c.dataset.id, type: c.dataset.type, name: c.dataset.name, price: parseFloat(c.dataset.unit) || 5, img: c.dataset.img, max, soldout: c.hasAttribute('data-soldout'), rank: i, el: c });
    });
    try { this.qvData = JSON.parse(q('[data-qv-data]').textContent); } catch (e) { this.qvData = {}; }
    /* sold-out products have no card; register them as sold out so old picks drop out and basket lines still price */
    try { Object.entries(JSON.parse(q('[data-oos-data]').textContent)).forEach(([id, o]) => { if (id !== '_' && o && !this.byId.has(id)) this.byId.set(id, { id, type: o.t, name: o.n, price: parseFloat(o.p) || 5, img: o.i, max: 0, soldout: true, rank: 1e6, el: null }); }); } catch (e) {}
    this.picks = []; this.basket = [];
    this.tray = q('[data-tray]'); this.nudge = q('[data-nudge]'); this.thumbs = q('[data-thumbs]'); this.bar = q('[data-bar]');
    this.countEl = q('[data-count]'); this.priceEl = q('[data-tray-price]'); this.cta = q('[data-cta]'); this.alt = q('[data-alt]'); this.fill = q('[data-fill]');
    this.miniMain = q('[data-mini-main]'); this.miniSub = q('[data-mini-sub]'); this.toggle = q('[data-toggle]');
    this.err = q('[data-err]'); this.oos = q('[data-oos]');
    this.qv = q('[data-qv-modal]');
    this.pickKey = 'rb8picks:8for24';
    const gone = [], seen = {};
    try {
      JSON.parse(sessionStorage.getItem(this.pickKey) || '[]').forEach(([id, nm]) => {
        const p = this.byId.get(String(id)); seen[id] = (seen[id] || 0) + 1;
        if (p && !p.soldout && (p.max == null || seen[id] <= p.max)) this.picks.push(String(id)); else if (!gone.includes(nm)) gone.push(nm);
      });
    } catch (e) {}
    if (gone.length && this.oos) { this.oos.textContent = gone.join(', ') + (gone.length > 1 ? ' have' : ' has') + ' sold out since you picked ' + (gone.length > 1 ? 'them' : 'it') + ', so we have taken ' + (gone.length > 1 ? 'them' : 'it') + ' out.'; this.oos.hidden = false; }
    this.bind();
    this.render();
    this.loadBasket();
    if ('ResizeObserver' in window && this.tray) new ResizeObserver(() => document.documentElement.style.setProperty('--rb8g-tray-h', this.tray.offsetHeight + 'px')).observe(this.tray);
  }

  /* ---- pricing (Multi-Deal v2) ---- */
  best(n) { let b = n * 5, singles = n; for (let a = 0; a * 12 <= n; a++) { const r = n - a * 12; const p = a * 35 + Math.floor(r / 8) * 24 + (r % 8) * 5; if (p < b || (p === b && r % 8 < singles)) { b = p; singles = r % 8; } } return { price: b, singles }; }
  priceOf(c) { const s20 = Math.floor(c.snap / 20); return s20 * 40 + this.best(c.snap - s20 * 20 + c.carpet + c.mist).price; }
  money(n) { return '£' + (Math.round(n * 100) / 100).toFixed(2); }
  mix(ids) { const c = { snap: 0, carpet: 0, mist: 0 }; ids.forEach((id) => { const p = this.byId.get(id); if (p) c[p.type] += 1; }); return c; }
  basketIds() { const a = []; this.basket.forEach((b) => { for (let i = 0; i < b.qty; i++) a.push(b.id); }); return a; }
  fullOf(ids) { return ids.reduce((t, id) => t + ((this.byId.get(id) || {}).price || 5), 0); }

  /* ---- basket ---- */
  async loadBasket() {
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const cart = await (await fetch(root + 'cart.js', { cache: 'no-store' })).json();
      this.basket = [];
      cart.items.forEach((it) => {
        if (it.properties && it.properties._gift) return;
        if (it.selling_plan_allocation) return;
        if (this.byId.has(String(it.variant_id))) this.basket.push({ id: String(it.variant_id), qty: it.quantity });
      });
      this.render();
    } catch (e) {}
  }
  inBasketOf(id) { return this.basket.filter((b) => b.id === String(id)).reduce((t, b) => t + b.qty, 0); }
  leftOf(id) { const p = this.byId.get(String(id)); if (!p || p.soldout) return 0; if (p.max == null) return Infinity; return Math.max(0, p.max - this.inBasketOf(id)); }
  countOf(id) { return this.picks.filter((x) => x === String(id)).length; }

  add(id) {
    id = String(id);
    if (this.countOf(id) >= this.leftOf(id)) { const p = this.byId.get(id), l = this.leftOf(id); this.say(l > 0 ? 'Only ' + l + ' ' + p.name + ' left, so that is the most you can add.' : 'Sorry, ' + p.name + ' has just sold out.'); return; }
    this.picks.push(id); this.render();
  }
  remove(id) { const i = this.picks.lastIndexOf(String(id)); if (i >= 0) { this.picks.splice(i, 1); this.render(); } }
  say(msg) { if (!this.err) return; this.err.textContent = msg; this.err.hidden = false; clearTimeout(this._t); this._t = setTimeout(() => { this.err.hidden = true; }, 7000); }

  /* Best-seller mix (cards are in the collection's best-seller order): 4 carpet : 3 snap : 1 mini per 8, no repeated scent names. */
  fillBest() {
    const all = this.basketIds().concat(this.picks);
    const total = all.length;
    let need = (this.target(this.mix(all)) || total) - total;
    if (need <= 0) return;
    const SHARE = { carpet: 4 / 8, snap: 3 / 8, mist: 1 / 8 };
    const have = this.mix(all), names = new Set(all.map((id) => (this.byId.get(id) || {}).name));
    const used = new Set(all);
    const byType = {};
    Object.keys(SHARE).forEach((t) => { byType[t] = Array.from(this.byId.values()).filter((p) => p.type === t && !used.has(p.id) && this.leftOf(p.id) > 0).sort((a, b) => a.rank - b.rank); });
    while (need > 0) {
      const filled = have.snap + have.carpet + have.mist + 1;
      const order = Object.keys(SHARE).filter((t) => byType[t].length).sort((x, y) => (have[x] - SHARE[x] * filled) - (have[y] - SHARE[y] * filled));
      if (!order.length) break;
      const t = order[0];
      let i = byType[t].findIndex((p) => !names.has(p.name)); if (i < 0) i = 0;
      const p = byType[t].splice(i, 1)[0];
      this.picks.push(p.id); have[t] += 1; names.add(p.name); need--;
    }
    this.render();
  }

  /* Next sensible stop: 8, then the next count with no £5 singles left over (12, 16, 20 ...). */
  target(c) {
    const s20 = Math.floor(c.snap / 20), pool = c.snap - s20 * 20 + c.carpet + c.mist;
    if (pool + s20 * 20 === 0) return 8;
    if (pool === 0) return 0;
    if (pool < 8) return s20 * 20 + 8;
    if (this.best(pool).singles === 0) return 0;
    for (let k = 1; k <= 11; k++) if (this.best(pool + k).singles === 0) return s20 * 20 + pool + k;
    return 0;
  }

  bind() {
    this.addEventListener('click', (e) => {
      const card = e.target.closest('.rb8g-card');
      if (card) {
        if (e.target.closest('[data-qv]')) { this.openQv(card.dataset.id); return; }
        if (e.target.closest('[data-add]') || e.target.closest('[data-plus]')) this.add(card.dataset.id);
        else if (e.target.closest('[data-minus]')) this.remove(card.dataset.id);
        return;
      }
      if (e.target.closest('[data-qv-act]') && this.qvId) {
        if (e.target.closest('[data-add]') || e.target.closest('[data-plus]')) this.add(this.qvId);
        else if (e.target.closest('[data-minus]')) this.remove(this.qvId);
        return;
      }
      if (e.target.closest('[data-qv-close]') || e.target === this.qv) this.closeQv();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.qv && !this.qv.hidden) this.closeQv(); });
    this.cta.addEventListener('click', () => this.onCta());
    this.fill.addEventListener('click', () => this.fillBest());
    this.alt.addEventListener('click', () => this.addToCart());
    this.toggle.addEventListener('click', () => { const open = !this.tray.classList.contains('is-open'); this.tray.classList.toggle('is-open', open); this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); this.toggle.setAttribute('aria-label', open ? 'Hide your bundle' : 'Show your bundle'); });
    document.addEventListener('cart:change', () => this.loadBasket());
    const at = this.querySelector('[data-tab].is-active'); this.tab = at ? at.dataset.tab : 'snap'; this.query = ''; this.autumn = false;
    this.querySelectorAll('[data-tab]').forEach((b) => b.addEventListener('click', () => this.setTab(b.dataset.tab)));
    const sb = this.querySelector('[data-search]');
    if (sb) sb.addEventListener('input', () => { this.query = sb.value.trim().toLowerCase(); this.applyFilter(); });
    const af = this.querySelector('[data-autumn-filter]');
    if (af) af.addEventListener('click', () => { this.autumn = !this.autumn; af.setAttribute('aria-pressed', this.autumn ? 'true' : 'false'); this.applyFilter(); });
  }
  setTab(t) {
    this.tab = t;
    this.querySelectorAll('[data-tab]').forEach((b) => { const on = b.dataset.tab === t; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    this.querySelectorAll('[data-panel]').forEach((p) => { p.hidden = p.dataset.panel !== t; });
    this.applyFilter();
    const bar = this.querySelector('.rb8g__tabs'), main = this.querySelector('.rb8g__main');
    const top = main.getBoundingClientRect().top + window.scrollY - (bar ? bar.offsetHeight : 0) - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0) - 4;
    if (window.scrollY > top) window.scrollTo({ top, behavior: 'auto' });
  }
  applyFilter() {
    let shown = 0;
    this.cards.forEach((c) => {
      if (c.dataset.type !== this.tab) return;
      const ok = (!this.query || (c.dataset.search || '').indexOf(this.query) !== -1) && (!this.autumn || c.hasAttribute('data-autumn'));
      c.hidden = !ok; if (ok) shown++;
    });
    const none = this.querySelector('[data-none]'); if (none) none.hidden = shown > 0;
  }

  openQv(id) {
    const p = this.byId.get(String(id)), d = this.qvData[String(id)] || {};
    if (!p || !this.qv) return;
    this.qvId = String(id); this._qvFrom = document.activeElement;
    const s = (sel) => this.qv.querySelector(sel);
    s('[data-qv-img]').src = d.i || ''; s('[data-qv-img]').alt = p.name;
    s('[data-qv-type]').textContent = d.t || ''; s('[data-qv-name]').textContent = p.name;
    s('[data-qv-notes]').textContent = d.n || ''; s('[data-qv-notes]').hidden = !d.n;
    s('[data-qv-desc]').textContent = (d.d || '').trim();
    s('[data-qv-link]').href = d.u || '#';
    s('[data-qv-also]').hidden = p.type !== 'snap';
    const desc = s('[data-qv-desc]'), more = s('[data-qv-more]');
    desc.classList.remove('is-open');
    requestAnimationFrame(() => { more.hidden = desc.scrollHeight <= desc.clientHeight + 2; });
    more.onclick = () => { desc.classList.add('is-open'); more.hidden = true; };
    this.qv.hidden = false; document.body.style.overflow = 'hidden';
    this.renderQvAct();
    s('[data-qv-close]').focus();
  }
  closeQv() { if (!this.qv) return; this.qv.hidden = true; this.qvId = null; document.body.style.overflow = ''; if (this._qvFrom && this._qvFrom.focus) this._qvFrom.focus(); }
  actHtml(id, big) {
    const k = this.countOf(id), cap = k >= this.leftOf(id), p = this.byId.get(id);
    if (p && p.soldout) return '<button type="button" class="rb8g-add" disabled>Sold out</button>';
    if (!k) return `<button type="button" class="rb8g-add" data-add${cap ? ' disabled' : ''}>${cap ? 'Sold out' : (big ? '+ Add to my 8' : '+ Add')}</button>`;
    return `<div class="rb8g-step"><button type="button" class="rb8g-step__b" data-minus aria-label="Remove one">&minus;</button><span aria-live="polite">${k}${big ? ' in your bundle' : ''}</span><button type="button" class="rb8g-step__b" data-plus aria-label="Add one more"${cap ? ' disabled' : ''}>+</button></div>`;
  }
  renderQvAct() { if (!this.qv || this.qv.hidden || !this.qvId) return; this.qv.querySelector('[data-qv-act]').innerHTML = this.actHtml(this.qvId, true); }

  onCta() {
    const all = this.basketIds().concat(this.picks);
    if (!all.length) { this.fillBest(); return; }
    if (all.length < 8) { this.toGrid(); return; }
    if (this.picks.length) this.addToCart(); else this.toGrid();
  }
  toGrid() {
    const first = this.cards.find((c) => c.dataset.type === this.tab && !c.hidden && !c.hasAttribute('data-soldout') && !this.countOf(c.dataset.id)) || this.cards.find((c) => !c.hasAttribute('data-soldout') && !this.countOf(c.dataset.id));
    if (first && first.dataset.type !== this.tab) this.setTab(first.dataset.type);
    if (!first) return;
    const r = first.getBoundingClientRect();
    if (r.top < 80 || r.bottom > window.innerHeight - 120) window.scrollTo({ top: r.top + window.scrollY - 160, behavior: 'smooth' });
    first.classList.remove('is-flash'); void first.offsetWidth; first.classList.add('is-flash');
  }

  render() {
    try { if (this.picks.length) sessionStorage.setItem(this.pickKey, JSON.stringify(this.picks.map((id) => [id, (this.byId.get(id) || {}).name]))); else sessionStorage.removeItem(this.pickKey); } catch (e) {}
    const bIds = this.basketIds(), all = bIds.concat(this.picks);
    const total = all.length, inB = bIds.length, n = this.picks.length;
    const c = this.mix(all);
    const price = this.priceOf(c), full = this.fullOf(all), base = this.priceOf(this.mix(bIds));
    const delta = Math.round((price - base) * 100) / 100;
    const tg = this.target(c);

    /* cards */
    this.cards.forEach((card) => {
      const id = card.dataset.id, k = this.countOf(id), ib = this.inBasketOf(id), act = card.querySelector('[data-act]');
      card.classList.toggle('is-picked', k > 0);
      const inEl = card.querySelector('[data-in]');
      if (inEl) { inEl.hidden = !ib; inEl.textContent = ib ? ib + ' in your basket' : ''; }
      if (card.hasAttribute('data-soldout') || !act) return;
      const key = k + (k >= this.leftOf(id) ? 'c' : '');
      if (act.dataset.key !== key) { act.dataset.key = key; act.innerHTML = this.actHtml(id, false); }
    });
    this.renderQvAct();

    /* ladder: highlight the deal the basket reaches */
    const s20 = Math.floor(c.snap / 20), pool = c.snap - s20 * 20 + c.carpet + c.mist;
    const p12 = pool >= 12 && this.best(pool).price < Math.floor(pool / 8) * 24 + (pool % 8) * 5;
    const on = { '8': pool >= 8 && !p12, '12': p12, '20': s20 > 0 };
    this.querySelectorAll('[data-tier]').forEach((li) => li.classList.toggle('is-on', !!on[li.dataset.tier]));

    /* nudge (expanded tray / desktop) and the short line for the collapsed phone tray */
    let nudge = '', short = '';
    const snapRem = c.snap % 20;
    if (total > 0 && total < 8) { nudge = 'Add ' + (8 - total) + ' more and all 8 drop to £3 each'; short = (8 - total) + ' more and all 8 are £24'; }
    else if (snapRem >= 12) { const k = 20 - snapRem; const p2 = this.priceOf({ snap: c.snap + k, carpet: c.carpet, mist: c.mist }); nudge = 'Add ' + k + ' more Snap Bar' + (k > 1 ? 's' : '') + ': 20 Snap Bars are £40' + (p2 > price ? ' (' + this.money(p2 - price) + ' more)' : (p2 < price ? ' (you pay ' + this.money(price - p2) + ' less)' : '')); short = k + ' more Snap Bar' + (k > 1 ? 's' : '') + ' for 20 at £40'; }
    else if (tg && total >= 8) { const k = tg - total; const p2 = this.priceOf({ snap: c.snap, carpet: c.carpet + k, mist: c.mist }); nudge = 'Add ' + k + ' more and pay ' + this.money(p2) + ' for ' + tg + (p2 > price ? ' (' + this.money(p2 - price) + ' more)' : ''); short = k + ' more: ' + tg + ' for ' + this.money(p2).replace('.00', ''); }
    else if (total >= 8) {
      if (s20 > 0 && pool === 0) nudge = (s20 > 1 ? s20 + ' x ' : '') + '20 Snap Bars for £40 unlocked';
      else if (pool === 8) { const p2 = this.priceOf({ snap: c.snap, carpet: c.carpet + 4, mist: c.mist }); nudge = '8 for £24 unlocked. 4 more makes 12 for £35 (' + this.money(p2 - price) + ' more)'; }
      else if (pool === 12) nudge = '12 for £35 unlocked';
      else nudge = total + ' items at the best bundle price';
      short = full > price ? 'You save ' + this.money(full - price) : nudge;
    }
    this.nudge.hidden = !nudge; this.nudge.textContent = nudge;
    if (!total) { this.miniMain.textContent = 'Pick any 8 for £24'; this.miniSub.textContent = '£3 each, save £16'; }
    else if (total < 8) { this.miniMain.textContent = total + ' of 8 · ' + this.money(price); this.miniSub.textContent = short; }
    else { this.miniMain.textContent = total + ' items · ' + this.money(price); this.miniSub.textContent = short; }

    /* thumbs */
    const slots = Math.max(8, Math.min(tg || total, 12));
    const mob = window.matchMedia('(max-width: 999px)').matches;
    let th = '';
    if (total) { for (let i = 0; i < Math.min(slots, mob ? 8 : 16); i++) { const id = all[i]; const p = id && this.byId.get(id); th += p ? `<img src="${p.img}" alt="" class="${i < inB ? 'is-basket' : ''}" width="34" height="34">` : '<span></span>'; } }
    this.thumbs.innerHTML = th;
    this.thumbs.style.gridTemplateColumns = mob ? '' : 'repeat(' + Math.min(slots, 8) + ', minmax(0,1fr))';

    /* bar + line */
    const goal = tg || total || 8;
    this.bar.style.width = (total ? Math.min(100, Math.round(total / goal * 100)) : 0) + '%';
    if (!total) { this.countEl.innerHTML = '<strong>0 of 8 picked</strong>'; this.priceEl.textContent = 'Pick 8, pay £24'; }
    else if (total < 8) { this.countEl.innerHTML = '<strong>' + total + ' of 8</strong>' + (inB ? ' (' + inB + ' in basket)' : '') + ' &middot; now ' + this.money(price); this.priceEl.innerHTML = 'At 8: <strong>£24.00</strong>'; }
    else { this.countEl.innerHTML = '<strong>' + total + ' items</strong>' + (inB ? ' (' + inB + ' in basket)' : ''); this.priceEl.innerHTML = (full > price ? '<s>' + this.money(full) + '</s> ' : '') + '<strong>' + this.money(price) + '</strong>'; }

    /* CTA: below 8 it never adds; a full-price add is a separate, labelled link */
    this.cta.classList.toggle('is-outline', !total);
    if (!total) this.cta.textContent = 'Fill with best sellers';
    else if (total < 8) this.cta.textContent = 'Pick ' + (8 - total) + ' more';
    else if (!n) this.cta.textContent = tg ? 'Pick ' + (tg - total) + ' more' : 'Pick more scents';
    else if (inB === 0) this.cta.textContent = 'Add ' + n + ' · ' + this.money(price).replace('.00', '');
    else this.cta.textContent = delta < 0 ? 'Add ' + n + ' & save ' + this.money(-delta) : (delta === 0 ? 'Add ' + n + ' at no extra cost' : 'Add ' + n + ' · +' + this.money(delta).replace('.00', ''));
    this.fill.hidden = !(total > 0 && total < 8);
    this.alt.hidden = !(n > 0 && total < 8);
    if (n > 0 && total < 8) this.alt.textContent = 'Add ' + n + ' at full price (' + this.money(delta).replace('.00', '') + ')';
  }

  async addToCart() {
    if (!this.picks.length || this.cta.getAttribute('aria-busy') === 'true') return;
    const cnts = {}; this.picks.forEach((id) => { cnts[id] = (cnts[id] || 0) + 1; });
    const before = {}; Object.keys(cnts).forEach((id) => { before[id] = this.inBasketOf(id); });
    const items = Object.keys(cnts).map((id) => ({ id: parseInt(id, 10), quantity: cnts[id], properties: { _from: '8for24-builder' } }));
    this.cta.setAttribute('aria-busy', 'true'); const label = this.cta.textContent; this.cta.textContent = 'Adding…';
    if (this.err) this.err.hidden = true;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const sections = ['cart-drawer', 'cart-count'];
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items }) });
      const added = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(added.description || 'Could not add to your basket. Please try again.');
      await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ attributes: { _source: '8for24-builder' } }) }).catch(() => {});
      const cart = await (await fetch(root + 'cart.js', { cache: 'no-store' })).json();
      cart.sections = await (await fetch(root + '?sections=' + sections.join(','), { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' })).json();
      this.picks = [];
      this.tray.classList.remove('is-open');
      this.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: Array.isArray(added.items) ? added.items : [added], cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
      await this.loadBasket();
      const short = Object.keys(cnts).map((id) => ({ id, got: this.inBasketOf(id) - (before[id] || 0), want: cnts[id] })).filter((x) => x.got < x.want);
      if (short.length) this.say(short.map((x) => { const p = this.byId.get(x.id); return x.got > 0 ? 'Only ' + x.got + ' ' + p.name + ' left, so we added ' + x.got + '.' : 'Sorry, ' + p.name + ' has just sold out.'; }).join(' '));
    } catch (e) {
      await this.loadBasket();
      const added = Object.keys(cnts).reduce((t, id) => t + Math.max(0, this.inBasketOf(id) - (before[id] || 0)), 0);
      if (added > 0) this.picks = [];
      this.say((e && e.message) || 'Something went wrong. Please try again.');
      try { const cart = await (await fetch(root + 'cart.js', { cache: 'no-store' })).json(); cart.sections = await (await fetch(root + '?sections=' + sections.join(','), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })).json(); document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } })); } catch (x) {}
    } finally {
      this.cta.removeAttribute('aria-busy'); if (this.cta.textContent === 'Adding…') this.cta.textContent = label;
      this.render();
    }
  }
}
if (!customElements.get('rb-8-grid')) customElements.define('rb-8-grid', Rb8Grid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-bundle-hero"] && !Shopify.designMode) return;
  try {
    
class RbSbGallery extends HTMLElement {
  connectedCallback() {
    this.main = this.querySelector('[data-sbg-main]');
    this.thumbs = Array.from(this.querySelectorAll('.rb-sbg__thumb'));
    if (!this.main || !this.thumbs.length) return;
    this.thumbs.forEach((btn) => btn.addEventListener('click', () => this.select(btn)));
  }
  select(btn) {
    const full = btn.getAttribute('data-full');
    if (!full) return;
    const full2x = btn.getAttribute('data-full2x') || full;
    this.main.src = full;
    this.main.srcset = full + ' 1000w, ' + full2x + ' 1500w';
    const alt = btn.getAttribute('data-alt');
    if (alt) this.main.alt = alt;
    this.thumbs.forEach((t) => t.classList.toggle('is-active', t === btn));
  }
}
if (!customElements.get('rb-sb-gallery')) {
  customElements.define('rb-sb-gallery', RbSbGallery);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-ck-hero"] && !Shopify.designMode) return;
  try {
    
class RbCkGallery extends HTMLElement {
  connectedCallback() {
    this.main = this.querySelector('[data-ckg-main]');
    this.video = this.querySelector('[data-ckg-video]');
    this.thumbs = Array.from(this.querySelectorAll('.rb-ckg__thumb'));
    if (!this.main || !this.thumbs.length) return;
    this.thumbs.forEach((btn) => btn.addEventListener('click', () => this.select(btn)));
    this.dots = Array.from(this.querySelectorAll('.rb-ckg__dot'));
    const stage = this.querySelector('.rb-ckg__stage');
    if (this.dots.length && stage) {
      let x0 = null, y0 = null;
      stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        const i = this.thumbs.findIndex((t) => t.classList.contains('is-active'));
        const n = this.thumbs.length;
        this.select(this.thumbs[(i + (dx < 0 ? 1 : -1) + n) % n]);
      });
    }
  }
  select(btn) {
    const vsrc = btn.getAttribute('data-video');
    if (this.video) {
      if (vsrc) {
        if (this.video.getAttribute('src') !== vsrc) { this.video.src = vsrc; this.video.poster = btn.getAttribute('data-full') || ''; }
        this.video.hidden = false;
        const p = this.video.play(); if (p && p.catch) p.catch(() => {});
        this.thumbs.forEach((t) => t.classList.toggle('is-active', t === btn));
        this.syncDots(btn);
        this.fitStage(btn);
        return;
      }
      this.video.pause(); this.video.hidden = true;
    }
    const full = btn.getAttribute('data-full');
    if (!full) return;
    this.fitStage(btn);
    const full2x = btn.getAttribute('data-full2x') || full;
    this.main.src = full;
    this.main.srcset = full + ' 1100w, ' + full2x + ' 1600w';
    const alt = btn.getAttribute('data-alt');
    if (alt) this.main.alt = alt;
    this.thumbs.forEach((t) => t.classList.toggle('is-active', t === btn));
    this.syncDots(btn);
  }
  /* Mobile value-box layout: the stage takes each slide's own ratio (full width, no crop), animating the height. */
  fitStage(btn) {
    const stage = this.querySelector('.rb-ckg__stage');
    if (!stage || !this.closest('.rb-ck--valuebox, .rb-ck--fit') || !window.matchMedia('(max-width: 749px)').matches) return;
    const ar = parseFloat(btn.getAttribute('data-ar')) || 1;
    const from = stage.offsetHeight;
    stage.style.height = '';
    stage.style.setProperty('--ckg-ar', ar);
    const to = stage.offsetHeight;
    if (Math.abs(to - from) < 1) return;
    stage.style.height = from + 'px';
    void stage.offsetHeight;
    stage.style.height = to + 'px';
    clearTimeout(this.fitTimer);
    this.fitTimer = setTimeout(() => { stage.style.height = ''; }, 350);
  }
  syncDots(btn) {
    const i = this.thumbs.indexOf(btn);
    this.classList.toggle('is-not-first', i > 0);
    if (!this.dots || !this.dots.length) return;
    this.dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
  }
}
if (!customElements.get('rb-ck-gallery')) customElements.define('rb-ck-gallery', RbCkGallery);

/* Sticky bar: shown once the main button has scrolled above the viewport. */
if (!window.rbCkSticky) {
  window.rbCkSticky = true;
  const initSticky = () => {
    document.querySelectorAll('[data-ck-sticky]').forEach((bar) => {
      const sec = bar.closest('.rb-ck');
      if (!sec || !sec.querySelector('.rb-ck__atc')) return;
      const before = bar.hasAttribute('data-ck-sticky-before');
      const mainBtn = () => { const all = Array.from(sec.querySelectorAll('.rb-ck__form .rb-ck__atc')); return all.find((b) => b.offsetHeight > 0 && getComputedStyle(b).position !== 'fixed') || all[0]; };
      let shown = null, queued = false;
      const update = () => {
        queued = false;
        const r = mainBtn().getBoundingClientRect();
        const show = r.height > 0 && (r.bottom < 0 || (before && r.top > window.innerHeight - 24));
        if (show === shown) return;
        shown = show;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.querySelector('button').tabIndex = show ? 0 : -1;
      };
      const onScroll = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();
  /* One add per tap: ignore a second submit of the kit form while the first is in flight. */
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || !form.classList || !form.classList.contains('rb-ck__form')) return;
    if (form.dataset.ckBusy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    form.dataset.ckBusy = '1';
    setTimeout(() => { delete form.dataset.ckBusy; }, 2500);
  }, true);
}

/* Second calendar: the tick sets the form quantity (2 or 1) and updates every price on the
   buttons (incl. the Essential Pre-order clone) and the sticky bar. No price change, no discount. */
if (!window.rbCkGift) {
  window.rbCkGift = true;
  const syncGift = (box) => {
    const gift = box.closest('[data-ck-gift]');
    const form = box.closest('form');
    const sec = box.closest('.rb-ck');
    if (!gift || !form || !sec) return;
    const two = box.checked;
    const qty = form.querySelector('input[name="quantity"]');
    if (qty) qty.value = two ? '2' : '1';
    sec.querySelectorAll('[data-ck-now]').forEach((el) => { el.textContent = two ? gift.dataset.two : gift.dataset.one; });
    sec.querySelectorAll('[data-ck-was]').forEach((el) => { el.textContent = two ? gift.dataset.wasTwo : gift.dataset.wasOne; });
  };
  document.addEventListener('change', (e) => { if (e.target.matches && e.target.matches('[data-ck-gift-box]')) syncGift(e.target); });
  const initGift = () => document.querySelectorAll('[data-ck-gift-box]').forEach(syncGift);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGift); else initGift();
  window.addEventListener('pageshow', initGift);
}

/* Buy now: add the set with its selling plan, then go straight to checkout (skips the cart drawer).
   Capture phase on document so Impact's product-form handler never sees the submit. */
if (!window.rbCkBuyNow) {
  window.rbCkBuyNow = true;
  document.addEventListener('submit', (e) => {
    const form = e.target;
    const btn = form && form.querySelector && form.querySelector('[data-ck-buy-now]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.classList.contains('is-loading')) return;
    const err = form.querySelector('[data-ck-buy-error]');
    if (err) err.hidden = true;
    const fd = new FormData(form);
    fd.set('selling_plan', btn.getAttribute('data-ck-buy-now'));
    fd.delete('return_to');
    btn.classList.add('is-loading');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    }).then((r) => r.json().then((j) => ({ ok: r.ok, j }))).then(({ ok, j }) => {
      if (!ok) throw new Error(j && (j.description || j.message) || 'Sorry, something went wrong. Please try again.');
      window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
    }).catch((ex) => {
      btn.classList.remove('is-loading');
      if (err) { err.textContent = ex.message; err.hidden = false; }
    });
  }, true);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-giftcard"]) return;
  try {
    
(function () {
  function init(root) {
    var toggle = root.querySelector('[data-rb-gc-toggle]');
    var fields = root.querySelector('[data-rb-gc-fields]');
    if (!toggle || !fields) return;
    var update = function () {
      fields.hidden = !toggle.checked;
      fields.querySelectorAll('input, textarea').forEach(function (el) { el.disabled = !toggle.checked; });
      var email = fields.querySelector('input[type=email]');
      if (email) email.required = toggle.checked;
    };
    toggle.addEventListener('change', update);
    update();
  }
  document.querySelectorAll('.rb-gc').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.rb-gc').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-header"] && !Shopify.designMode) return;
  try {
    
/* Rebrand: Header — vanilla, section-scoped, theme-editor safe. */
(function () {
  if (window.__rbHeaderBooted) return;
  window.__rbHeaderBooted = true;

  var HOVER_OPEN_DELAY = 60;
  var HOVER_CLOSE_DELAY = 180;
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function canHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function RbHeader(root) {
    this.root = root;
    this.abort = new AbortController();
    this.signal = this.abort.signal;
    this.openTrigger = null;
    this.openTimer = null;
    this.closeTimer = null;
    this.suppressFocusOpen = false;
    this.drawerReturnFocus = null;

    this.triggers = Array.prototype.slice.call(root.querySelectorAll('[data-rb-mega-trigger]'));
    this.drawer = root.querySelector('[data-rb-drawer]');
    this.drawerToggle = root.querySelector('[data-rb-drawer-toggle]');
    this.drawerClose = root.querySelector('[data-rb-drawer-close]');

    /* The rest of the theme offsets sticky/scroll positions with this flag
       (see snippets/css-variables.liquid --sticky-area-height). */
    document.documentElement.style.setProperty(
      '--sticky-header-enabled',
      root.getAttribute('data-sticky') === 'true' ? '1' : '0'
    );

    this._bindMegaMenus();
    this._bindDrawer();
  }

  RbHeader.prototype.panelFor = function (trigger) {
    var id = trigger.getAttribute('aria-controls');
    return id ? this.root.querySelector('#' + CSS.escape(id)) : null;
  };

  RbHeader.prototype.openMega = function (trigger) {
    var panel = this.panelFor(trigger);
    if (!panel) return;
    if (this.openTrigger && this.openTrigger !== trigger) this.closeMega(this.openTrigger);
    window.clearTimeout(this.closeTimer);
    trigger.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-open');
    this.openTrigger = trigger;
  };

  RbHeader.prototype.closeMega = function (trigger) {
    var panel = this.panelFor(trigger);
    trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.classList.remove('is-open');
    if (this.openTrigger === trigger) this.openTrigger = null;
  };

  RbHeader.prototype.closeAllMega = function () {
    var self = this;
    this.triggers.forEach(function (trigger) {
      self.closeMega(trigger);
    });
  };

  RbHeader.prototype.scheduleClose = function () {
    var self = this;
    window.clearTimeout(this.openTimer);
    window.clearTimeout(this.closeTimer);
    this.closeTimer = window.setTimeout(function () {
      self.closeAllMega();
    }, HOVER_CLOSE_DELAY);
  };

  RbHeader.prototype.cancelClose = function () {
    window.clearTimeout(this.closeTimer);
  };

  RbHeader.prototype._bindMegaMenus = function () {
    var self = this;
    var opts = { signal: this.signal };

    this.triggers.forEach(function (trigger) {
      var panel = self.panelFor(trigger);

      trigger.addEventListener(
        'mouseenter',
        function () {
          if (!canHover()) return;
          self.cancelClose();
          window.clearTimeout(self.openTimer);
          self.openTimer = window.setTimeout(function () {
            self.openMega(trigger);
          }, HOVER_OPEN_DELAY);
        },
        opts
      );

      trigger.addEventListener(
        'mouseleave',
        function () {
          window.clearTimeout(self.openTimer);
          self.scheduleClose();
        },
        opts
      );

      /* Keyboard focus opens the panel so it is never hover-only. */
      trigger.addEventListener(
        'focus',
        function () {
          if (self.suppressFocusOpen) return;
          self.cancelClose();
          self.openMega(trigger);
        },
        opts
      );

      trigger.addEventListener(
        'keydown',
        function (event) {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            self.openMega(trigger);
            var first = panel && panel.querySelector(FOCUSABLE);
            if (first) first.focus();
          }
        },
        opts
      );

      /* Touch / no-hover pointers: first tap opens, second follows the link. */
      trigger.addEventListener(
        'click',
        function (event) {
          if (canHover()) return;
          if (trigger.getAttribute('aria-expanded') !== 'true') {
            event.preventDefault();
            self.openMega(trigger);
          }
        },
        opts
      );

      if (panel) {
        panel.addEventListener('mouseenter', function () { self.cancelClose(); }, opts);
        panel.addEventListener('mouseleave', function () { self.scheduleClose(); }, opts);
      }
    });

    if (this.triggers.length) {
      this.root.addEventListener(
        'focusout',
        function (event) {
          if (!event.relatedTarget || !self.root.contains(event.relatedTarget)) {
            self.closeAllMega();
          }
        },
        opts
      );

      this.root.addEventListener(
        'keydown',
        function (event) {
          if (event.key !== 'Escape' || !self.openTrigger) return;
          var trigger = self.openTrigger;
          self.closeMega(trigger);
          /* Re-focusing the trigger must not immediately re-open the panel. */
          self.suppressFocusOpen = true;
          trigger.focus();
          self.suppressFocusOpen = false;
        },
        opts
      );

      document.addEventListener(
        'click',
        function (event) {
          if (!self.root.contains(event.target)) self.closeAllMega();
        },
        opts
      );
    }
  };

  /* ------------------------------------------------------------- drawer --- */

  RbHeader.prototype.openDrawer = function () {
    if (!this.drawer) return;
    this.drawerReturnFocus = document.activeElement;
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    if (this.drawerToggle) this.drawerToggle.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('rb-scroll-lock');
    var first = this.drawerClose || this.drawer.querySelector(FOCUSABLE);
    if (first) first.focus();
  };

  RbHeader.prototype.closeDrawer = function (restoreFocus) {
    if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    if (this.drawerToggle) this.drawerToggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('rb-scroll-lock');
    if (restoreFocus !== false && this.drawerReturnFocus && this.drawerReturnFocus.focus) {
      this.drawerReturnFocus.focus();
    }
    this.drawerReturnFocus = null;
  };

  RbHeader.prototype._bindDrawer = function () {
    if (!this.drawer || !this.drawerToggle) return;
    var self = this;
    var opts = { signal: this.signal };

    this.drawerToggle.addEventListener(
      'click',
      function () {
        if (self.drawer.classList.contains('is-open')) self.closeDrawer();
        else self.openDrawer();
      },
      opts
    );

    if (this.drawerClose) {
      this.drawerClose.addEventListener('click', function () { self.closeDrawer(); }, opts);
    }

    this.drawer.addEventListener(
      'keydown',
      function (event) {
        if (event.key === 'Escape') {
          event.stopPropagation();
          self.closeDrawer();
          return;
        }
        if (event.key !== 'Tab') return;

        var items = Array.prototype.filter.call(
          self.drawer.querySelectorAll(FOCUSABLE),
          function (el) { return el.offsetParent !== null; }
        );
        if (!items.length) return;

        var first = items[0];
        var last = items[items.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      },
      opts
    );

    /* Following a link inside the drawer (including the search-drawer
       trigger) should not leave the page scroll-locked. */
    this.drawer.addEventListener(
      'click',
      function (event) {
        if (event.target.closest('a[href]')) self.closeDrawer(false);
      },
      opts
    );

    window.addEventListener(
      'resize',
      function () {
        if (window.matchMedia('(min-width: 1000px)').matches) self.closeDrawer(false);
      },
      opts
    );
  };

  RbHeader.prototype.destroy = function () {
    window.clearTimeout(this.openTimer);
    window.clearTimeout(this.closeTimer);
    this.closeDrawer(false);
    this.closeAllMega();
    this.abort.abort();
  };

  function boot(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var roots = Array.prototype.slice.call(container.querySelectorAll('[data-rb-header]'));
    if (container !== document && container.matches && container.matches('[data-rb-header]')) {
      roots.push(container);
    }
    roots.forEach(function (root) {
      if (!root.rbHeaderInstance) root.rbHeaderInstance = new RbHeader(root);
    });
  }

  function teardown(scope) {
    if (!scope || !scope.querySelectorAll) return;
    Array.prototype.slice.call(scope.querySelectorAll('[data-rb-header]')).forEach(function (root) {
      if (root.rbHeaderInstance) {
        root.rbHeaderInstance.destroy();
        root.rbHeaderInstance = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Theme editor: sections are re-rendered wholesale, so re-init every time. */
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    teardown(event.target);
  });

  /* Selecting a mega-menu block in the editor should reveal its panel. */
  document.addEventListener('shopify:block:select', function (event) {
    var panel = event.target.closest('[data-rb-mega-panel]');
    if (!panel) return;
    var root = panel.closest('[data-rb-header]');
    if (!root || !root.rbHeaderInstance) return;
    var trigger = root.querySelector('[data-rb-mega-trigger][aria-controls="' + panel.id + '"]');
    if (trigger) root.rbHeaderInstance.openMega(trigger);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var panel = event.target.closest('[data-rb-mega-panel]');
    if (!panel) return;
    var root = panel.closest('[data-rb-header]');
    if (root && root.rbHeaderInstance) root.rbHeaderInstance.closeAllMega();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-hero"] && !Shopify.designMode) return;
  try {
    
class RbHeroSlides extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.rb-heros__slide'));
    this.dots = Array.from(this.querySelectorAll('.rb-heros__dot'));
    if (this.slides.length < 2) return;
    this.i = 0;
    this.interval = parseInt(this.dataset.interval, 10) || 6000;
    this.dots.forEach((d, idx) => d.addEventListener('click', () => { this.go(idx); this.restart(); }));
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.start();
  }
  go(n) {
    this.i = (n + this.slides.length) % this.slides.length;
    this.slides.forEach((s, idx) => s.classList.toggle('is-active', idx === this.i));
    this.dots.forEach((d, idx) => d.classList.toggle('is-active', idx === this.i));
  }
  start() { this.stop(); this.timer = setInterval(() => this.go(this.i + 1), this.interval); }
  stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
  restart() { this.start(); }
  disconnectedCallback() { this.stop(); }
}
if (!customElements.get('rb-hero-slides')) customElements.define('rb-hero-slides', RbHeroSlides);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-new-scents"] && !Shopify.designMode) return;
  try {
    
  /**
   * Rebrand: Discover Our New Scents tab switcher.
   * Custom element so it re-initialises automatically on theme editor section reloads.
   */
  if (!customElements.get('rb-scent-tabs')) {
    customElements.define(
      'rb-scent-tabs',
      class RbScentTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

          this.onClick = this.onClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.onBlockSelect = this.onBlockSelect.bind(this);

          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKeydown);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        onClick(event) {
          const tab = event.target.closest('[role="tab"]');

          if (!tab || !this.tabs.includes(tab)) return;

          event.preventDefault();
          this.select(this.tabs.indexOf(tab));
        }

        onKeydown(event) {
          const tab = event.target.closest('[role="tab"]');

          if (!tab || !this.tabs.includes(tab)) return;

          const current = this.tabs.indexOf(tab);
          let next = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            next = (current + 1) % this.tabs.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            next = (current - 1 + this.tabs.length) % this.tabs.length;
          } else if (event.key === 'Home') {
            next = 0;
          } else if (event.key === 'End') {
            next = this.tabs.length - 1;
          }

          if (next === null) return;

          event.preventDefault();
          this.select(next, true);
        }

        onBlockSelect(event) {
          if (!this.contains(event.target)) return;

          const index = this.panels.findIndex(function (panel) {
            return panel.contains(event.target) || event.target.getAttribute('aria-controls') === panel.id;
          });

          if (index > -1) this.select(index);
        }

        select(index, focusTab) {
          this.tabs.forEach(function (tab, i) {
            tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
            tab.setAttribute('tabindex', i === index ? '0' : '-1');
          });

          this.panels.forEach(function (panel, i) {
            if (i === index) {
              panel.removeAttribute('hidden');
            } else {
              panel.setAttribute('hidden', '');
            }
          });

          if (focusTab && this.tabs[index]) {
            this.tabs[index].focus();
            this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-review-strip"] && !Shopify.designMode) return;
  try {
    
class RbReviewRotator extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.rb-review__item'));
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.items.length < 2 || this.reduced) return;

    this.index = 0;
    this.interval = parseInt(this.dataset.interval, 10) || 5000;
    this.advance = this.advance.bind(this);
    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.sync = this.sync.bind(this);

    document.addEventListener('visibilitychange', this.sync);
    this.addEventListener('pointerenter', this.stop);
    this.addEventListener('pointerleave', this.start);
    this.addEventListener('focusin', this.stop);
    this.addEventListener('focusout', this.start);

    this.start();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.sync);
  }

  sync() {
    document.hidden ? this.stop() : this.start();
  }

  start() {
    if (this.timer) return;
    this.timer = window.setInterval(this.advance, this.interval);
  }

  stop() {
    window.clearInterval(this.timer);
    this.timer = null;
  }

  advance() {
    this.items[this.index].removeAttribute('data-active');
    this.index = (this.index + 1) % this.items.length;
    this.items[this.index].setAttribute('data-active', '');
  }
}

if (!customElements.get('rb-review-rotator')) {
  customElements.define('rb-review-rotator', RbReviewRotator);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-sb-hero"] && !Shopify.designMode) return;
  try {
    
class RbSbGallery extends HTMLElement {
  connectedCallback() {
    this.main = this.querySelector('[data-sbg-main]');
    this.thumbs = Array.from(this.querySelectorAll('.rb-sbg__thumb'));
    if (!this.main || !this.thumbs.length) return;
    this.thumbs.forEach((btn) => {
      btn.addEventListener('click', () => this.select(btn));
    });
  }
  select(btn) {
    const full = btn.getAttribute('data-full');
    if (!full) return;
    const full2x = btn.getAttribute('data-full2x') || full;
    this.main.src = full;
    this.main.srcset = full + ' 1000w, ' + full2x + ' 1500w';
    const alt = btn.getAttribute('data-alt');
    if (alt) this.main.alt = alt;
    this.thumbs.forEach((t) => t.classList.toggle('is-active', t === btn));
  }
}
if (!customElements.get('rb-sb-gallery')) {
  customElements.define('rb-sb-gallery', RbSbGallery);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-sb-included"] && !Shopify.designMode) return;
  try {
    
class RbSbScents extends HTMLElement {
  connectedCallback() {
    this.scents = this.querySelector('.rb-sb-included__scents');
    this.btn = this.querySelector('.rb-sb-included__more');
    if (!this.scents || !this.btn) return;
    this.mq = window.matchMedia('(max-width: 749px)');
    this.update = this.update.bind(this);
    this.btn.addEventListener('click', () => {
      const open = this.classList.toggle('is-expanded');
      this.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.btn.textContent = open ? 'See less' : 'See more';
    });
    this.mq.addEventListener('change', this.update);
    window.addEventListener('resize', this.update);
    this.update();
  }
  update() {
    if (!this.mq.matches) {
      this.btn.hidden = true;
      this.classList.remove('is-expanded');
      this.btn.textContent = 'See more';
      this.btn.setAttribute('aria-expanded', 'false');
      return;
    }
    const wasOpen = this.classList.contains('is-expanded');
    this.classList.remove('is-expanded');
    const overflows = this.scents.scrollHeight > this.scents.clientHeight + 2;
    this.btn.hidden = !overflows;
    if (wasOpen && overflows) this.classList.add('is-expanded');
  }
}
if (!customElements.get('rb-sb-scents')) {
  customElements.define('rb-sb-scents', RbSbScents);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-shop-by-product"] && !Shopify.designMode) return;
  try {
    
  /**
   * Rebrand: Shop by Product tab switcher.
   * Custom element so it re-initialises automatically on theme editor section reloads.
   */
  if (!customElements.get('rb-product-tabs')) {
    customElements.define(
      'rb-product-tabs',
      class RbProductTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

          this.onClick = this.onClick.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.onBlockSelect = this.onBlockSelect.bind(this);

          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKeydown);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        onClick(event) {
          const tab = event.target.closest('[role="tab"]');

          if (!tab || !this.tabs.includes(tab)) return;

          event.preventDefault();
          this.select(this.tabs.indexOf(tab));
        }

        onKeydown(event) {
          const tab = event.target.closest('[role="tab"]');

          if (!tab || !this.tabs.includes(tab)) return;

          const current = this.tabs.indexOf(tab);
          let next = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            next = (current + 1) % this.tabs.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            next = (current - 1 + this.tabs.length) % this.tabs.length;
          } else if (event.key === 'Home') {
            next = 0;
          } else if (event.key === 'End') {
            next = this.tabs.length - 1;
          }

          if (next === null) return;

          event.preventDefault();
          this.select(next, true);
        }

        onBlockSelect(event) {
          if (!this.contains(event.target)) return;

          const index = this.panels.findIndex(function (panel) {
            return panel.contains(event.target) || event.target.getAttribute('aria-controls') === panel.id;
          });

          if (index > -1) this.select(index);
        }

        select(index, focusTab) {
          this.tabs.forEach(function (tab, i) {
            tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
            tab.setAttribute('tabindex', i === index ? '0' : '-1');
          });

          this.panels.forEach(function (panel, i) {
            if (i === index) {
              panel.removeAttribute('hidden');
            } else {
              panel.setAttribute('hidden', '');
            }
          });

          if (focusTab && this.tabs[index]) {
            this.tabs[index].focus();
            this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-snap-hero"] && !Shopify.designMode) return;
  try {
    
class RbSnhGallery extends HTMLElement {
  connectedCallback() {
    this.main = this.querySelector('[data-snhg-main]');
    this.thumbs = Array.from(this.querySelectorAll('.rb-snhg__thumb'));
    if (!this.main || !this.thumbs.length) return;
    this.thumbs.forEach((btn) => btn.addEventListener('click', () => this.select(btn)));
  }
  select(btn) {
    const full = btn.getAttribute('data-full');
    if (!full) return;
    const full2x = btn.getAttribute('data-full2x') || full;
    this.main.src = full;
    this.main.srcset = full + ' 1100w, ' + full2x + ' 1500w';
    const alt = btn.getAttribute('data-alt');
    if (alt) this.main.alt = alt;
    this.thumbs.forEach((t) => t.classList.toggle('is-active', t === btn));
  }
}
if (!customElements.get('rb-snh-gallery')) customElements.define('rb-snh-gallery', RbSnhGallery);

class RbSnhQty extends HTMLElement {
  connectedCallback() {
    this.unit = parseInt(this.dataset.unit, 10) || 0;
    this.input = this.querySelector('[data-qval]');
    this.label = this.querySelector('[data-atc-label]');
    this.minus = this.querySelector('[data-qminus]');
    this.plus = this.querySelector('[data-qplus]');
    if (!this.input) return;
    this.minus && this.minus.addEventListener('click', () => this.bump(-1));
    this.plus && this.plus.addEventListener('click', () => this.bump(1));
    this.input.addEventListener('input', () => this.sync());
    this.input.addEventListener('blur', () => this.sync(true));
  }
  bump(d) { this.setQty((parseInt(this.input.value, 10) || 1) + d); }
  setQty(q) { q = Math.max(1, Math.min(20, q || 1)); this.input.value = q; this.sync(); }
  sync(clamp) {
    let q = parseInt(this.input.value, 10);
    if (isNaN(q) || q < 1) { if (clamp) { q = 1; this.input.value = 1; } else return; }
    if (this.label && this.unit) {
      this.label.textContent = (this.label.dataset.verb || this.label.textContent.split(' – ')[0]) + ' – ' + this.money(this.unit * q);
    }
  }
  money(cents) { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }).format(cents / 100); }
}
if (!customElements.get('rb-snh-qty')) customElements.define('rb-snh-qty', RbSnhQty);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-usp-bar"] && !Shopify.designMode) return;
  try {
    
class RbUspRotator extends HTMLElement {
  connectedCallback() {
    this.pages = Array.from(this.querySelectorAll('.rb-usp__page'));
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.pages.length < 2 || this.reduced) return;

    this.mql = window.matchMedia('(max-width: 999px)');
    this.index = 0;
    this.interval = parseInt(this.dataset.interval, 10) || 3500;

    this.advance = this.advance.bind(this);
    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.sync = this.sync.bind(this);

    this.mql.addEventListener('change', this.sync);
    document.addEventListener('visibilitychange', this.sync);
    this.addEventListener('pointerenter', this.stop);
    this.addEventListener('pointerleave', this.start);
    this.addEventListener('focusin', this.stop);
    this.addEventListener('focusout', this.start);

    this.sync();
  }

  disconnectedCallback() {
    this.stop();
    if (this.mql) this.mql.removeEventListener('change', this.sync);
    document.removeEventListener('visibilitychange', this.sync);
  }

  sync() {
    (this.mql.matches && !document.hidden) ? this.start() : this.stop();
  }

  start() {
    if (this.timer || !this.mql.matches) return;
    this.timer = window.setInterval(this.advance, this.interval);
  }

  stop() {
    window.clearInterval(this.timer);
    this.timer = null;
  }

  advance() {
    this.pages[this.index].removeAttribute('data-active');
    this.index = (this.index + 1) % this.pages.length;
    this.pages[this.index].setAttribute('data-active', '');
  }
}

if (!customElements.get('rb-usp-rotator')) {
  customElements.define('rb-usp-rotator', RbUspRotator);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  /**
   * Rebrand: Video testimonials.
   * Custom element so it re-initialises automatically on theme editor section reloads.
   * The player markup lives in a <template> per card, so nothing is requested
   * from YouTube / Vimeo / the CDN until the shopper actually clicks play.
   */
  if (!customElements.get('rb-video-testimonials')) {
    customElements.define(
      'rb-video-testimonials',
      class RbVideoTestimonials extends HTMLElement {
        connectedCallback() {
          this.onClick = this.onClick.bind(this);
          this.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          this.stopAll();
        }

        get cards() {
          return Array.from(this.querySelectorAll('[data-rb-vt-card]'));
        }

        onClick(event) {
          const trigger = event.target.closest('[data-rb-vt-trigger]');

          if (!trigger || !this.contains(trigger)) return;

          const card = trigger.closest('[data-rb-vt-card]');

          if (!card) return;

          event.preventDefault();
          this.play(card);
        }

        play(card) {
          const stage = card.querySelector('[data-rb-vt-stage]');
          const template = stage && stage.querySelector('[data-rb-vt-player]');

          if (!stage || !template || stage.hasAttribute('data-rb-vt-playing')) return;

          // Only one testimonial plays at a time.
          this.cards.forEach((other) => {
            if (other !== card) this.stop(other);
          });

          stage.appendChild(template.content.cloneNode(true));
          stage.setAttribute('data-rb-vt-playing', 'true');

          const video = stage.querySelector('video.rb-vt-card__video');

          if (!video) return;

          // Still inside the click handler, so user activation allows sound.
          const attempt = video.play();

          if (attempt && typeof attempt.catch === 'function') {
            // Autoplay refused: the native controls stay available.
            attempt.catch(() => {});
          }

          video.focus({ preventScroll: true });
        }

        stop(card) {
          const stage = card.querySelector('[data-rb-vt-stage]');
          const player = stage && stage.querySelector('.rb-vt-card__video');

          if (!stage || !player) return;

          // Removing the node stops <video> playback and tears down any iframe.
          player.remove();
          stage.removeAttribute('data-rb-vt-playing');
        }

        stopAll() {
          this.cards.forEach((card) => this.stop(card));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
